<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Exam Plan </strong>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn small rounded @click="openExamPlanDialog()"> + add exam plan</v-btn>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined persistent-hint
                        hint="Please select academic year" />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="sem" item-value="id" label="Semester" persistent-hint
                        hint="Please select semester" />
                </v-col>
                <v-col cols="12" sm="1" md="1">
                    <v-btn class="mt-7" color="primary" :loading="get_loader" rounded @click="getData();">Fetch</v-btn>
                </v-col>
            </v-row>

            <v-row v-if="exam_plan_list != ''" justify="center" dense class="no-display">
                <v-col cols="12" sm="12" md="12">
                    <v-data-table :headers="headers" :items="exam_plan_list" class="elevation-1 mytable" dense
                        v-if="exam_plan_list != ''">
                        <template v-slot:item.exam_name="{ item }">
                            <div class="d-flex align-center detail-btn">
                                {{ item.exam_name }}
                                <v-btn icon @click="viewDetails(item)">
                                    <v-avatar size="25">
                                        <v-icon color="indigo">mdi-arrow-right-bold-box</v-icon>
                                    </v-avatar>
                                </v-btn>
                            </div>
                        </template>
                        <template v-slot:item.isApproved="{ item }">
                            <v-switch v-model="item.isApproved"
                                @change="savePlanStatus(item, 'is_approved', item.isApproved)" hide-details inset dense
                                style="justify-content: center;"></v-switch>
                        </template>
                        <template v-slot:item.isCurrent="{ item }">
                            <v-switch v-model="item.isCurrent" style="justify-content: center;" hide-details inset dense
                                @change="savePlanStatus(item, 'iscurrent', item.isCurrent)"></v-switch>
                        </template>
                        <template v-slot:item.add_crs_schedule="{ item }">
                            <v-btn rounded small class="mb-2 button" @click="addSchedule(item)">Add Course
                                Schedule</v-btn>
                        </template>
                        <template v-slot:item.delete="{ item }">
                            <v-btn :disabled="item.delete == false" icon @click="deleteSchedule(item)">
                                <v-avatar size="25" class="delete-avatar">
                                    <v-icon small color="black">mdi-delete</v-icon>
                                </v-avatar>
                            </v-btn>
                        </template>
                        <template v-slot:item.edit="{ item }">
                            <v-btn icon @click="openEditExamPlan(item)">
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon small color="black">mdi-pencil</v-icon>
                                </v-avatar>
                            </v-btn>
                        </template>
                        <template v-slot:item.is_seating_arrangment_freezed="{ item }">
                            <v-switch v-model="item.is_seating_arrangment_freezed" style="justify-content: center;"
                                hide-details inset dense
                                @change="savePlanStatus(item, 'is_freezed', item.is_seating_arrangment_freezed)"></v-switch>
                        </template>
                        <template v-slot:item.supervisor_enabled="{ item }">
                            <v-switch v-model="item.supervisor_enabled" style="justify-content: center;" hide-details
                                inset dense
                                @change="savePlanStatus(item, 'supervisor_enabled', item.supervisor_enabled)"></v-switch>
                        </template>
                        <template v-slot:item.benchwise_allocation="{ item }">
                            <v-switch v-model="item.benchwise_allocation" hide-details inset dense
                                style="justify-content: center;"
                                @change="savePlanStatus(item, 'benchwise_allocation', item.benchwise_allocation)"></v-switch>
                        </template>
                        <template v-slot:item.subjectwise_schedule="{ item }">
                            <v-btn icon small title="View Subjectwise Schedule">
                                <v-icon v-if="item.has_coursewise_schedule" @click="viewExamCoursewiseSchedule(item)"
                                    color="primary">
                                    mdi-eye
                                </v-icon>
                            </v-btn>

                            <v-btn icon small title="Add Subjectwise Schedule"
                                @click="openExamCoursewiseSchedule(item)">
                                <v-icon color="orange">
                                    mdi-plus-circle
                                </v-icon>
                            </v-btn>

                        </template>
                        <template v-slot:item.assign_bench_side="{ item }">
                            <v-btn small icon title="Assign Bench Side" @click="openAssignBenchSideDialog(item)">
                                <v-icon color="green">
                                    mdi-plus-circle
                                </v-icon>
                            </v-btn>
                        </template>

                        <template v-slot:item.offer_room="{ item }">
                            <v-btn small icon color="primary" @click="openOfferRoomDialog(item)">
                                +
                                <v-icon>
                                    mdi-door-open
                                </v-icon>
                            </v-btn>
                        </template>

                        <template v-slot:item.maximum_number_of_slots_in_day="{ item }">
                            <v-btn small icon title="Add slot" @click="openExamSlotDialog(item)">
                                <v-icon color="green">
                                    mdi-plus-circle
                                </v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:item.seating_arrangement="{ item }">

                            <v-btn icon small title="View Seating Arrangement">
                                <v-icon color="primary" v-if="item.has_seating_arrangement"
                                    @click="viewSeatingArrangement(item)">
                                    mdi-eye
                                </v-icon>
                            </v-btn>

                            <v-btn icon small title="Reload Seating Arrangement" @click="openSeatingArrangement(item)">
                                <v-icon color="orange">
                                    mdi-plus-circle
                                </v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:item.door_display_report="{ item }">
                            <v-btn icon small title="View Door Display Report" @click="openDoorDisplayReport(item)">
                                <v-icon color="primary">
                                    mdi-eye
                                </v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:item.supervisor_report="{ item }">
                            <v-btn icon small title="View Supervisor Report" @click="openSupervisorReport(item)">
                                <v-icon color="primary">
                                    mdi-eye
                                </v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:item.student_attendance_report="{ item }">
                            <v-btn icon small title="View Student Attendance Report"
                                @click="openStudentAttendanceReport(item)">
                                <v-icon color="primary">
                                    mdi-eye
                                </v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:item.room_utilization_report="{ item }">
                            <v-btn icon small title="View Room Utilization Report"
                                @click="openRoomUtilizationReport(item)">
                                <v-icon color="primary">
                                    mdi-eye
                                </v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card>

        <v-dialog v-model="dialog_add" max-width="1900px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>Add Subject Schedule</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row v-if="exam_plan_data != null" dense justify="center">
                            <v-col cols="12" sm="3" md="3">
                                <v-autocomplete color="#0F2027" dense rounded required v-model="exam_crs_std"
                                    item-value="id" :items="exam_plan_data.std_list" item-text="std"
                                    label="Select Standard" outlined persistent-hint
                                    @change="getStdCourse(exam_crs_std)" hint="Please Select Standard" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3" v-if="crs_list != ''">
                                <v-autocomplete color="#0F2027" dense rounded required v-model="crs_id"
                                    item-value="c_id" :items="crs_list" item-text="course" label="Course" outlined
                                    persistent-hint hint="Please select course" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-autocomplete color="#0F2027" dense rounded required v-model="exam_crs_slot"
                                    item-value="eds_id" :items="exam_plan_data.exam_detailed_schedule_list"
                                    item-text="slot" label="Select Slot" outlined persistent-hint
                                    hint="Please Select slot" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-btn class="button" :disabled="exam_plan_data.isApproved"
                                    v-if="exam_crs_slot && crs_id && exam_crs_std"
                                    @click="saveCrsExamPlan(exam_crs_slot, exam_crs_std, crs_id)">Save</v-btn>
                            </v-col>
                        </v-row>
                        <v-col cols="12" sm="12" md="12" v-if="exam_crs_sechedule_list != ''">
                            <v-toolbar class="toolbar no-display" flat dense>
                                <v-toolbar-title>
                                    <strong> Coursewise Exam Plan Details </strong>
                                </v-toolbar-title>
                            </v-toolbar>
                            <br />
                            <v-data-table :headers="headers_crs" :items="bookList1" class="elevation-1 mytable"
                                @current-items="getFiltered" dense v-if="exam_crs_sechedule_list != ''">
                                <template v-slot:top class="pb-5">
                                    <v-row justify="center">
                                        <v-col cols="12" sm="12" md="12">
                                            <tr class="t-row">
                                                <div>
                                                    <th>
                                                        <v-row>
                                                            <span v-for="header in headers_crs" :key="header.text">
                                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                                    <v-autocomplete class="mr-2 pb-5 pt-2" flat
                                                                        hide-details small rounded dense outlined
                                                                        color="#0F2027" :label="header.text" multiple
                                                                        clearable :items="columnValueList(header.value)"
                                                                        v-model="filters[header.value]"></v-autocomplete>
                                                                </span>
                                                            </span>
                                                        </v-row>
                                                    </th>
                                                </div>
                                            </tr>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-card>
                    <v-row justify="center">
                        <v-btn class="button" @click="dialog_add = false">Cancel</v-btn>
                    </v-row>
                </v-col>
            </v-card>
        </v-dialog>
        <v-dialog v-model="delete_dailog" max-width="700px">
            <v-card>
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong> Delete Exam Plan </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="delete_dailog = false"><v-icon> mdi-close
                        </v-icon></v-btn>
                </v-toolbar>
                <br>
                <center>
                    <strong>Are you sure you want delete this exam plan???</strong>
                </center>
                <br>
                <v-row justify="center">
                    <v-btn class="button" text @click="delete_dailog = false">No</v-btn>
                    <v-btn class="button" text :loading="delete_loader" @click="deleteExamPlan(exam_plan_id)">
                        YES
                    </v-btn>
                </v-row>
                <br>
            </v-card>
        </v-dialog>
        <v-dialog v-model="examPlanDialog" max-width="1000px">
            <v-card class="rounded-lg exam-plan-dialog">
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-icon color="white" class="mr-2">
                        mdi-clipboard-text-outline
                    </v-icon>

                    <v-toolbar-title>
                        <strong>Add Exam Plan</strong>
                    </v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn icon small @click="examPlanDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text class="pa-4">
                    <div class="d-flex align-center mb-3">
                        <v-icon small color="primary" class="mr-2">
                            mdi-information-outline
                        </v-icon>
                        <strong>Exam Details</strong>
                    </div>

                    <v-row dense>
                        <v-col cols="12" md="6" class="pa-2">
                            <v-text-field label="Exam Name" rounded outlined dense v-model="exam_name"
                                hide-details="auto">
                                <template v-slot:label>
                                    Exam Name <span class="red--text">*</span>
                                </template>
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" md="6" class="pa-2">
                            <v-autocomplete dense required outlined rounded color="#0F2027" v-model="assessment_detail"
                                :items="assessment_detail_list" item-text="assessmenttype" item-value="id"
                                label="Assessment Type" hide-details="auto" @click="show = false">
                                <template v-slot:label>
                                    Assessment Type <span class="red--text">*</span>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" md="6" class="pa-2">
                            <v-autocomplete color="#0F2027" dense rounded required v-model="selAyData" return-object
                                :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined
                                hide-details="auto" @change="getStd();">
                                <template v-slot:label>
                                    Academic Year <span class="red--text">*</span>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" md="6" class="pa-2">
                            <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sel_sem"
                                :items="semester_list" item-text="sem" item-value="id" label="Semester"
                                hide-details="auto">
                                <template v-slot:label>
                                    Semester <span class="red--text">*</span>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" md="6" class="pa-2">
                            <v-autocomplete dense required outlined rounded color="#0F2027" v-model="stream"
                                :items="stream_list" item-text="str" item-value="str_id" label="Stream" multiple chips
                                clearable hide-details="auto">
                                <template v-slot:label>
                                    Stream <span class="red--text">*</span>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" md="6" v-if="std_div_list != null" class="pa-2">
                            <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" multiple
                                :items="std_div_list" item-text="std" item-value="std_id" label="Standard" outlined
                                hide-details="auto">
                                <template v-slot:label>
                                    Standard <span class="red--text">*</span>
                                </template>
                            </v-autocomplete>
                        </v-col>

                    </v-row>

                    <v-row class="mt-2 ml-0" align="center">

                        <v-col cols="12" md="6">
                            <div class="caption font-weight-medium mb-1">
                                Exam Conduct Type
                                <span class="red--text">*</span>
                            </div>

                            <v-radio-group v-model="exam_conduct_type_selected" mandatory row class="ma-0">
                                <v-radio v-for="type in exam_conduct_type" :key="type.id"
                                    :label="type.exam_conduct_type" :value="type.id" color="primary"></v-radio>
                            </v-radio-group>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-checkbox dense v-model="supervisor_enabled" color="success" class="mt-0" hide-details
                                label="Supervisor Enabled"></v-checkbox>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-checkbox dense v-model="benchwise_allocation" color="success" class="mt-0" hide-details
                                label="Benchwise Allocation"></v-checkbox>
                        </v-col>

                    </v-row>

                    <div class="d-flex align-center mt-2 mb-3">
                        <v-icon small color="primary" class="mr-2">
                            mdi-calendar-clock
                        </v-icon>
                        <strong>Exam Schedule</strong>
                    </div>

                    <v-row dense>

                        <v-col cols="12" md="4">
                            <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                                transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field dense outlined rounded v-model="new_from_date"
                                        @blur="date1 = parseDate(new_from_date)" v-on="on"
                                        prepend-inner-icon="mdi-calendar-start" persistent-hint label="From Date"
                                        readonly>
                                        <template v-slot:label>
                                            From Date <span class="red--text">*</span>
                                        </template>
                                    </v-text-field>
                                </template>

                                <v-date-picker v-model="date1" no-title @input="menu1 = false"></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="12" md="4">
                            <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                                transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field dense outlined rounded v-model="new_to_date"
                                        @blur="date2 = parseDate(new_to_date)" v-on="on"
                                        prepend-inner-icon="mdi-calendar-end" persistent-hint label="To Date" readonly>
                                        <template v-slot:label>
                                            To Date <span class="red--text">*</span>
                                        </template>
                                    </v-text-field>
                                </template>

                                <v-date-picker v-model="date2" no-title @input="menu2 = false"></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="12" md="4">
                            <v-text-field type="number" label="Max Slots In Day" rounded outlined dense
                                v-model="timeSlotCount" prepend-inner-icon="mdi-clock-plus-outline" hide-details="auto"
                                @change="generateTimeSlots()">
                                <template v-slot:label>
                                    Max Slots In Day <span class="red--text">*</span>
                                </template>
                            </v-text-field>
                        </v-col>

                    </v-row>

                    <div v-if="timeSlots.length" class="mt-2">

                        <div class="d-flex align-center mb-2">
                            <v-icon small color="primary" class="mr-2">
                                mdi-clock-outline
                            </v-icon>
                            <strong>Time Slots</strong>
                        </div>

                        <v-row dense>

                            <v-col v-for="(slot, index) in timeSlots" :key="index" cols="12" sm="6" md="3">
                                <v-card outlined class="pa-2 rounded">

                                    <div class="d-flex align-center justify-space-between mb-2">
                                        <span class="caption font-weight-bold">
                                            Slot {{ index + 1 }}
                                        </span>

                                        <v-icon small color="primary">
                                            mdi-clock-outline
                                        </v-icon>
                                    </div>

                                    <v-menu v-model="slot.menuFrom" :close-on-content-click="false"
                                        transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field rounded outlined dense v-model="slot.fromTime" class="mb-2"
                                                label="From Time" prepend-inner-icon="mdi-clock-start" readonly
                                                hide-details v-bind="attrs" v-on="on"></v-text-field>
                                        </template>

                                        <v-card>
                                            <v-time-picker v-model="slot.fromTime"
                                                @change="onTimeChange(index, 'fromTime', slot.fromTime)"></v-time-picker>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>

                                                <v-btn text @click="slot.menuFrom = false">
                                                    Cancel
                                                </v-btn>

                                                <v-btn text color="primary" @click="slot.menuFrom = false">
                                                    OK
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-menu>

                                    <v-menu v-model="slot.menuEnd" :close-on-content-click="false"
                                        transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field rounded outlined dense v-model="slot.endTime" label="End Time"
                                                prepend-inner-icon="mdi-clock-end" readonly hide-details v-bind="attrs"
                                                v-on="on"></v-text-field>
                                        </template>

                                        <v-card>
                                            <v-time-picker v-model="slot.endTime"
                                                @change="onTimeChange(index, 'endTime', slot.endTime)"></v-time-picker>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>

                                                <v-btn text @click="slot.menuEnd = false">
                                                    Cancel
                                                </v-btn>

                                                <v-btn text color="primary" @click="slot.menuEnd = false">
                                                    OK
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-menu>

                                </v-card>
                            </v-col>
                            <v-col cols="12" md="6" v-if="timeSlots.length">
                                <v-card outlined class="pa-3 rounded">
                                    <div class="d-flex align-center mb-2">
                                        <v-icon small color="success" class="mr-2">
                                            mdi-check-circle-outline
                                        </v-icon>

                                        <strong class="caption">
                                            Selected Time Slots
                                        </strong>
                                    </div>

                                    <div v-for="(slot, index) in timeSlots" :key="index" class="caption mb-1">
                                        <strong>Slot {{ index + 1 }} : </strong>
                                        {{ slot.fromTime || '--' }}
                                        <v-icon x-small class="mx-1">
                                            mdi-arrow-right
                                        </v-icon>
                                        {{ slot.endTime || '--' }}
                                    </div>
                                </v-card>
                            </v-col>

                        </v-row>

                    </div>

                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="px-4 py-3">

                    <v-btn text @click="examPlanDialog = false">
                        Cancel
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-btn color="primary" small :loading="fetch_loader" :disabled="!(
                        selAyData &&
                        sel_std_data &&
                        sel_std_data.length > 0 &&
                        stream &&
                        stream.length > 0 &&
                        sel_sem &&
                        new_from_date &&
                        new_to_date &&
                        exam_name &&
                        timeSlotCount
                    )" @click="saveplandetails()">
                        <v-icon small class="mr-1">
                            mdi-content-save
                        </v-icon>
                        Save Exam Plan
                    </v-btn>

                </v-card-actions>

            </v-card>
        </v-dialog>
        <v-dialog v-model="addExamSlotDialog" max-width="1100px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>Add Exam Slot</strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="addExamSlotDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-card class="box mb-4" outlined>
                        <v-card-title class="pb-2">
                            <strong>Exam Plan Details</strong>
                        </v-card-title>
                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th>Exam Plan</th>
                                    <th>Academic Year</th>
                                    <th>Semester</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>No. of Slots in Each Day</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="selectedExamPlan">
                                    <td>{{ selectedExamPlan.exam_name }}</td>
                                    <td> {{ selectedExamPlan.academicyear }}</td>
                                    <td>{{ selectedExamPlan.semester }}</td>
                                    <td>{{ selectedExamPlan.start_date }}</td>
                                    <td>{{ selectedExamPlan.end_date }}</td>
                                    <td>{{ selectedExamPlan.maximum_number_of_slots_in_day }}</td>
                                </tr>
                                <tr v-else>
                                    <td colspan="6" class="text-center">
                                        No exam plan selected
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card>
                    <v-row justify="end" class="mb-2">
                        <v-btn small class="button" @click="showAddSlotForm = !showAddSlotForm">
                            <v-icon left>
                                {{ showAddSlotForm ? 'mdi-close' : 'mdi-plus' }}
                            </v-icon>
                            {{ showAddSlotForm ? 'Cancel' : 'Add Slot' }}
                        </v-btn>
                    </v-row>
                    <v-card v-if="showAddSlotForm" class="pa-1 pt-0 mb-4" outlined>
                        <v-card-title>
                            <strong>Add New Slot</strong>
                        </v-card-title>
                        <v-row dense justify="center">
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field label="Slot No." type="number" outlined dense rounded
                                    v-model="newSlot.slot_no">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-menu v-model="newSlot.menuFrom" :close-on-content-click="false"
                                    transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="newSlot.from_time" label="From Time"
                                            prepend-icon="mdi-clock" readonly outlined dense rounded v-bind="attrs"
                                            v-on="on">
                                        </v-text-field>
                                    </template>
                                    <v-card>
                                        <v-time-picker v-model="newSlot.from_time">
                                        </v-time-picker>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn text @click="newSlot.menuFrom = false">
                                                Cancel
                                            </v-btn>
                                            <v-btn text @click="newSlot.menuFrom = false">
                                                OK
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-menu v-model="newSlot.menuTo" :close-on-content-click="false"
                                    transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="newSlot.to_time" label="To Time" prepend-icon="mdi-clock"
                                            readonly outlined dense rounded v-bind="attrs" v-on="on">
                                        </v-text-field>
                                    </template>
                                    <v-card>
                                        <v-time-picker v-model="newSlot.to_time"></v-time-picker>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn text @click="newSlot.menuTo = false">
                                                Cancel
                                            </v-btn>
                                            <v-btn text @click="newSlot.menuTo = false">
                                                OK
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-menu>
                            </v-col>

                            <v-col cols="12" sm="2" md="2">
                                <v-btn class="button mt-0" :loading="slot_loader" @click="addSlot">
                                    <v-icon left>mdi-plus</v-icon>
                                    Add
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-card class="box" outlined>
                        <v-card-title class="pb-2">
                            <strong>Exam Slots</strong>
                            <v-spacer></v-spacer>
                            <span>
                                Total Slots:
                                <b>{{ examSlotList.length }}</b>
                            </span>
                        </v-card-title>
                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th width="15%">Slot No.</th>
                                    <th width="25%">From Time</th>
                                    <th width="25%">To Time</th>
                                    <th width="15%">Status</th>
                                    <th width="20%">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(slot, index) in examSlotList" :key="slot.id || index">
                                    <td>{{ slot.slot_number }} </td>
                                    <td>{{ slot.from_time }}</td>
                                    <td>{{ slot.to_time }}</td>
                                    <td>
                                        <v-chip small :color="slot.isNew ? 'success' : 'primary'" text-color="white">
                                            {{ slot.isNew ? 'Newly Added' : 'Existing' }}
                                        </v-chip>
                                    </td>
                                    <td>
                                        <v-btn icon small title="Edit Slot" @click="openEditSlot(slot)">
                                            <v-icon color="primary">
                                                mdi-pencil
                                            </v-icon>
                                        </v-btn>
                                        <v-btn icon small title="Delete Slot" @click="openDeleteSlot(slot)">
                                            <v-icon color="red">
                                                mdi-trash-can
                                            </v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                                <tr v-if="examSlotList.length == 0">
                                    <td colspan="5" class="text-center grey--text">
                                        No slots available
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="button" @click="addExamSlotDialog = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="editExamSlotDialog" max-width="700px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>Edit Exam Slot</strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="editExamSlotDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12" sm="4" md="4" class="pt-4 pb-0">
                            <v-text-field label="Slot No." type="number" outlined dense rounded readonly filled
                                v-model="editSlot.slot_no">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-4 pb-0">
                            <v-menu v-model="editSlot.menuFrom" :close-on-content-click="false"
                                transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="editSlot.from_time" label="From Time"
                                        prepend-icon="mdi-clock" readonly outlined dense rounded v-bind="attrs"
                                        v-on="on">
                                    </v-text-field>
                                </template>
                                <v-card>
                                    <v-time-picker v-model="editSlot.from_time"></v-time-picker>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn text @click="editSlot.menuFrom = false">
                                            Cancel
                                        </v-btn>
                                        <v-btn text @click="editSlot.menuFrom = false">
                                            OK
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-4 pb-0">
                            <v-menu v-model="editSlot.menuTo" :close-on-content-click="false"
                                transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="editSlot.to_time" label="To Time" prepend-icon="mdi-clock"
                                        readonly outlined dense rounded v-bind="attrs" v-on="on">
                                    </v-text-field>
                                </template>
                                <v-card>
                                    <v-time-picker v-model="editSlot.to_time"></v-time-picker>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn text @click="editSlot.menuTo = false">
                                            Cancel
                                        </v-btn>
                                        <v-btn text @click="editSlot.menuTo = false">
                                            OK
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="editExamSlotDialog = false">
                        Cancel
                    </v-btn>
                    <v-btn class="button" :loading="edit_slot_loader" @click="updateExamSlot">
                        Update
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="deleteExamSlotDialog" max-width="500px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>Delete Exam Slot</strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="deleteExamSlotDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="text-center">
                    <br>
                    <strong> Are you sure you want to delete Slot {{ selectedDeleteSlot ? selectedDeleteSlot.slot_number
                        : ''
                        }}?</strong>
                    <br>
                    <br>
                    <span v-if="selectedDeleteSlot">
                        {{ selectedDeleteSlot.from_time }} - {{ selectedDeleteSlot.to_time }}
                    </span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="deleteExamSlotDialog = false">No</v-btn>
                    <v-btn class="button" :loading="delete_slot_loader" @click="deleteExamSlot">Yes</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>

        </v-dialog>
        <v-dialog v-model="assignBenchSideDialog" max-width="1000px" persistent>
            <v-card>
                <v-toolbar dense flat color="primary" dark>
                    <v-toolbar-title>
                        Assign Bench Side
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="assignBenchSideDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <div class="text-subtitle-1 font-weight-bold mb-2">
                        Exam Plan Details
                    </div>
                    <v-simple-table dense>
                        <thead>
                            <tr>
                                <th>Exam Plan</th>
                                <th>Academic Year</th>
                                <th>Semester</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>No. of Slots in Each Day</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="selectedBenchSideExamPlan">
                                <td>{{ selectedBenchSideExamPlan.exam_name }}</td>
                                <td>{{ selectedBenchSideExamPlan.academicyear }}</td>
                                <td>{{ selectedBenchSideExamPlan.semester }}</td>
                                <td>{{ selectedBenchSideExamPlan.start_date }}</td>
                                <td>{{ selectedBenchSideExamPlan.end_date }}</td>
                                <td>{{ selectedBenchSideExamPlan.maximum_number_of_slots_in_day }}</td>
                            </tr>

                            <tr v-else>
                                <td colspan="6" class="text-center">
                                    No exam plan selected
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>

                    <v-divider class="my-4"></v-divider>
                    <div class="text-subtitle-1 font-weight-bold mb-2">
                        Assign Bench Side
                    </div>

                    <v-row>
                        <v-col cols="12" md="4">
                            <v-select v-model="benchSideForm.stream_id" :items="benchSideStreamList" item-text="str"
                                item-value="str_id" label="Stream" outlined dense clearable hide-details></v-select>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-select v-model="benchSideForm.standard_id" :items="benchSideStandardList" item-text="std"
                                item-value="id" label="Standard" outlined dense clearable hide-details>
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-select v-model="benchSideForm.bench_side_id" :items="bench_side_list"
                                item-text="bench_name" item-value="id" label="Bench Side" outlined dense clearable
                                hide-details>
                            </v-select>
                        </v-col>
                    </v-row>

                    <div class="text-right mt-2">
                        <v-btn color="primary" small :loading="saveBenchSideLoader" :disabled="saveBenchSideLoader"
                            @click="saveExamStandardStreamBenchSide">
                            <v-icon left small>
                                mdi-plus
                            </v-icon>
                            Assign Bench Side
                        </v-btn>
                    </div>
                    <v-divider class="my-4"></v-divider>
                    <div class="text-subtitle-1 font-weight-bold mb-2">
                        Assigned Bench Sides
                    </div>

                    <v-data-table dense :headers="benchSideHeaders" :items="benchSideList" :loading="benchSideLoader"
                        class="elevation-1" no-data-text="No bench side assigned">
                        <template v-slot:item.action="{ item }">
                            <v-btn icon small color="primary" @click="editExamStandardStreamBenchSide(item)">
                                <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn icon small color="red" @click="deleteExamStandardStreamBenchSide(item)">
                                <v-icon small>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="editBenchSideDialog" max-width="600px" persistent>
            <v-card>
                <v-toolbar dense flat color="primary" dark>
                    <v-toolbar-title>
                        Edit Bench Side
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="editBenchSideDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-text-field :value="editBenchSideForm.stream" label="Stream" outlined dense
                                readonly></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field :value="editBenchSideForm.standard" label="Standard" outlined dense
                                readonly></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-select v-model="editBenchSideForm.bench_side_id" :items="bench_side_list"
                                item-text="bench_name" item-value="id" label="Bench Side" outlined dense clearable
                                hide-details></v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="editBenchSideDialog = false">
                        Cancel
                    </v-btn>
                    <v-btn color="primary" :loading="editBenchSideLoader" :disabled="editBenchSideLoader"
                        @click="updateExamStandardStreamBenchSide">
                        Update
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="offerRoomDialog" max-width="1000px" persistent>
            <v-card>
                <v-toolbar dense flat color="primary" dark>
                    <v-toolbar-title>
                        Offer Room for Exam Plan
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="offerRoomDialog = false">
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <div class="text-subtitle-1 font-weight-bold mb-2">
                        Exam Plan Details
                    </div>
                    <v-simple-table dense>
                        <thead>
                            <tr>
                                <th>Exam Plan</th>
                                <th>Academic Year</th>
                                <th>Semester</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>No. of Slots in Each Day</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="selectedOfferRoomExamPlan">
                                <td>{{ selectedOfferRoomExamPlan.exam_name }}</td>
                                <td>{{ selectedOfferRoomExamPlan.academicyear }}</td>
                                <td>{{ selectedOfferRoomExamPlan.semester }}</td>
                                <td>{{ selectedOfferRoomExamPlan.start_date }}</td>
                                <td>{{ selectedOfferRoomExamPlan.end_date }}</td>
                                <td>{{ selectedOfferRoomExamPlan.maximum_number_of_slots_in_day }}</td>
                            </tr>
                            <tr v-else>
                                <td colspan="6" class="text-center">
                                    No exam plan selected
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <v-divider class="my-4"></v-divider>
                    <div class="text-subtitle-1 font-weight-bold mb-2">
                        Offer Room
                    </div>
                    <v-row>
                        <v-col cols="12" md="3">
                            <v-select v-model="offerRoomForm.room_type_id" :items="roomTypeList" item-text="name"
                                item-value="id" label="Room Type" outlined dense clearable :loading="roomTypeLoader"
                                hide-details @change="getRoomsByRoomType">
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-select v-model="offerRoomForm.room_id" :items="roomList" item-text="roomnumber"
                                item-value="id" label="Room" outlined dense clearable :loading="roomLoader"
                                :disabled="!offerRoomForm.room_type_id" hide-details>
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field v-model.number="offerRoomForm.number_of_benches" label="Number of Benches"
                                type="number" min="1" outlined dense hide-details>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field v-model.number="offerRoomForm.capacity_per_bench" label="Capacity Per Bench"
                                type="number" min="1" outlined dense hide-details>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="2" class="d-flex align-center">
                            <div>
                                <div class="caption grey--text">
                                    Total Capacity
                                </div>
                                <div class="text-h6 font-weight-bold">
                                    {{ offerRoomTotalCapacity }}
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                    <div class="text-right mt-3">
                        <v-btn color="primary" small :loading="saveOfferRoomLoader" :disabled="saveOfferRoomLoader"
                            @click="saveExamRoomOffering">
                            <v-icon left small>
                                mdi-plus
                            </v-icon>
                            Offer Room
                        </v-btn>
                    </div>
                    <v-divider class="my-4"></v-divider>
                    <div class="text-subtitle-1 font-weight-bold mb-2">
                        Offered Rooms
                    </div>

                    <v-data-table dense :headers="offerRoomHeaders" :items="offerRoomList" :loading="offerRoomLoader"
                        class="elevation-1" no-data-text="No room offered">
                        <template v-slot:item.total_capacity="{ item }">
                            {{
                                Number(item.number_of_benches || 0) *
                                Number(item.capacity_per_bench || 0)
                            }}
                        </template>
                        <template v-slot:item.allocated_benches="{ item }">
                            <v-btn icon small color="primary" @click="openAllocatedBenchDialog(item)">
                                <v-icon>mdi-bench-back</v-icon>
                            </v-btn>
                        </template>

                        <template v-slot:item.action="{ item }">

                            <v-btn icon small color="primary" @click="editExamRoomOffering(item)">
                                <v-icon small>
                                    mdi-pencil
                                </v-icon>
                            </v-btn>

                            <v-btn icon small color="red" @click="deleteExamRoomOffering(item)">
                                <v-icon small>
                                    mdi-delete
                                </v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="editOfferRoomDialog" max-width="600px" persistent>
            <v-card>

                <v-card-title class="primary white--text">
                    Edit Room Offering
                    <v-spacer></v-spacer>

                    <v-btn icon dark @click="editOfferRoomDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pt-4">

                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <td><b>Room No</b></td>
                                <td>
                                    {{ selectedEditOfferRoom ? selectedEditOfferRoom.room_no : '' }}
                                </td>
                            </tr>

                            <tr>
                                <td><b>Room Type</b></td>
                                <td>
                                    {{ selectedEditOfferRoom ? selectedEditOfferRoom.room_type : '' }}
                                </td>
                            </tr>

                        </tbody>
                    </v-simple-table>

                    <v-row class="mt-3">

                        <v-col cols="12" sm="6">

                            <v-text-field v-model.number="editOfferRoomForm.number_of_benches" label="Number of Benches"
                                type="number" min="1" outlined dense></v-text-field>

                        </v-col>

                        <v-col cols="12" sm="6">

                            <v-text-field v-model.number="editOfferRoomForm.capacity_per_bench"
                                label="Capacity Per Bench" type="number" min="1" outlined dense></v-text-field>

                        </v-col>

                        <v-col cols="12">

                            <v-text-field :value="editOfferRoomTotalCapacity" label="Total Capacity" outlined dense
                                readonly></v-text-field>

                        </v-col>

                    </v-row>

                </v-card-text>

                <v-card-actions>

                    <v-spacer></v-spacer>

                    <v-btn text @click="editOfferRoomDialog = false">
                        Cancel
                    </v-btn>

                    <v-btn color="primary" dark :loading="editOfferRoomLoader" @click="updateExamRoomOffering">
                        Update
                    </v-btn>

                </v-card-actions>

            </v-card>
        </v-dialog>
        <v-dialog v-model="allocatedBenchDialog" max-width="1000px" persistent>
            <v-card>
                <v-card-title class="primary white--text">
                    Allocated Benches
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="allocatedBenchDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pt-4">
                    <v-simple-table dense class="mb-4">
                        <tbody>

                            <tr>
                                <td><b>Exam Plan</b></td>
                                <td>{{ selectedAllocatedBenchOffering ? selectedAllocatedBenchOffering.exam_plan : '' }}
                                </td>

                                <td><b>Academic Year</b></td>
                                <td>{{ selectedAllocatedBenchOffering ? selectedAllocatedBenchOffering.academic_year :
                                    '' }}
                                </td>

                                <td><b>Semester</b></td>
                                <td>{{ selectedAllocatedBenchOffering ? selectedAllocatedBenchOffering.semester : '' }}
                                </td>

                                <td><b>Start Date</b></td>
                                <td>{{ selectedAllocatedBenchOffering ? selectedAllocatedBenchOffering.start_date : ''
                                }}</td>

                                <td><b>End Date</b></td>
                                <td>{{ selectedAllocatedBenchOffering ? selectedAllocatedBenchOffering.end_date : '' }}
                                </td>
                            </tr>

                            <tr>
                                <td><b>No. of Slots in a Day</b></td>
                                <td>{{ selectedAllocatedBenchOffering ?
                                    selectedAllocatedBenchOffering.number_of_slots_in_day :
                                    '' }}</td>

                                <td><b>Room No.</b></td>
                                <td>{{ selectedAllocatedBenchOffering ? selectedAllocatedBenchOffering.room_no : '' }}
                                </td>

                                <td><b>Number of Benches</b></td>
                                <td>{{ selectedAllocatedBenchOffering ? selectedAllocatedBenchOffering.number_of_benches
                                    : '' }}
                                </td>

                                <td><b>Capacity Per Bench</b></td>
                                <td>{{ selectedAllocatedBenchOffering ?
                                    selectedAllocatedBenchOffering.capacity_per_bench : ''
                                }}</td>

                                <td><b>Total Capacity</b></td>
                                <td>{{ selectedAllocatedBenchOffering ? selectedAllocatedBenchOffering.total_capacity :
                                    '' }}
                                </td>
                            </tr>

                        </tbody>
                    </v-simple-table>

                    <v-card outlined class="pa-3 mb-4">
                        <div class="subtitle-1 font-weight-bold mb-3"> Allot Bench</div>
                        <v-row>
                            <v-col cols="12" sm="5">
                                <v-select v-model="allocatedBenchForm.bench_numbers" :items="availableBenchNumbers"
                                    label="Bench Numbers" multiple chips outlined dense clearable hide-details>
                                    <template v-slot:prepend-item>
                                        <v-list-item @click="toggleSelectAllBenches">
                                            <v-list-item-action>
                                                <v-checkbox :input-value="selected_all_benches"
                                                    @click.stop="toggleSelectAllBenches"></v-checkbox>
                                            </v-list-item-action>

                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    Select All
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>

                                        <v-divider></v-divider>
                                    </template>
                                </v-select>
                            </v-col>

                            <v-col cols="12" sm="5">
                                <v-select v-model="allocatedBenchForm.bench_side_id" :items="bench_side_list"
                                    item-text="bench_name" item-value="id" label="Bench Side" outlined dense clearable
                                    :loading="benchSideLoader" hide-details></v-select>
                            </v-col>

                            <v-col cols="12" sm="2" class="d-flex align-center">
                                <v-btn color="primary" dark block :loading="saveAllocatedBenchLoader"
                                    @click="saveAllocatedBench">
                                    Allot Bench
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                    <div class="subtitle-1 font-weight-bold mb-2">Allocated Benches</div>

                    <v-data-table :headers="allocatedBenchHeaders" :items="allocatedBenchList"
                        :loading="allocatedBenchLoader" dense bordered :items-per-page="10">
                        <template v-slot:item.bench_number="{ item }">
                            {{ item.bench_number }}
                        </template>
                        <template v-slot:item.bench_side="{ item }">
                            {{ item.bench_side || '-' }}
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-btn icon small color="error" @click="deleteBenchAllocation(item)">
                                <v-icon small>
                                    mdi-delete
                                </v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="allocatedBenchDialog = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="editExamPlanDialog" max-width="700px">
            <v-card>
                <v-card-title>
                    <span class="headline">Edit Exam Plan</span>
                </v-card-title>

                <v-card-text>

                    <v-text-field v-model="editExamPlan.exam_name" label="Exam Name" outlined dense>
                    </v-text-field>

                    <v-select v-model="editExamPlan.assessment_type_id" :items="assessment_detail_list"
                        item-text="assessmenttype" item-value="id" label="Assessment Type" outlined dense clearable>
                    </v-select>

                    <v-menu v-model="editStartDateMenu" :close-on-content-click="false" transition="scale-transition"
                        offset-y min-width="290px">

                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="editExamPlan.start_date" label="Start Date"
                                prepend-icon="mdi-calendar" readonly outlined dense v-bind="attrs" v-on="on">
                            </v-text-field>
                        </template>

                        <v-date-picker v-model="editExamPlan.start_date" @input="editStartDateMenu = false">
                        </v-date-picker>

                    </v-menu>
                    <v-menu v-model="editEndDateMenu" :close-on-content-click="false" transition="scale-transition"
                        offset-y min-width="290px">

                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="editExamPlan.end_date" label="End Date" prepend-icon="mdi-calendar"
                                readonly outlined dense v-bind="attrs" v-on="on">
                            </v-text-field>
                        </template>

                        <v-date-picker v-model="editExamPlan.end_date" @input="editEndDateMenu = false">
                        </v-date-picker>

                    </v-menu>

                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn text @click="editExamPlanDialog = false">
                        Cancel
                    </v-btn>

                    <v-btn color="primary" :loading="editExamPlanLoader" @click="updateExamPlan">
                        Update
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
        <v-dialog v-model="exam_coursewise_dialog" max-width="1200px" persistent>
            <v-card class="exam-coursewise-card">
                <v-card-title class="py-2 toolbar">
                    <span class="text-h6 font-weight-bold">Subject Wise Exam Schedule</span>
                    <v-spacer></v-spacer>
                    <v-btn icon color="white" @click="closeCoursewiseDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-3 exam-coursewise-body">
                    <v-card outlined class="mb-4 exam-summary-card">
                        <v-card-title class="py-2 text-subtitle-1 font-weight-bold">
                            <v-icon small class="mr-2">mdi-information-outline</v-icon>
                            Exam Plan Details
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="py-3">
                            <v-row dense>
                                <v-col cols="12" md="4">
                                    <div class="info-label">Exam Name</div>
                                    <div class="info-value">{{ exam_plan_data.exam_name || "-" }}</div>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <div class="info-label">Academic Year</div>
                                    <div class="info-value">{{ exam_plan_data.academic_year || "-" }}</div>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <div class="info-label">Semester</div>
                                    <div class="info-value">{{ exam_plan_data.semester || "-" }}</div>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <div class="info-label">Slots Per Day</div>
                                    <div class="info-value">
                                        {{ exam_plan_data.maximum_number_of_slots_in_day || "-" }}
                                    </div>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <div class="info-label">Start Date</div>
                                    <div class="info-value">
                                        {{ formatCoursewiseDate(exam_plan_data.start_date) || "-" }}
                                    </div>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <div class="info-label">End Date</div>
                                    <div class="info-value">
                                        {{ formatCoursewiseDate(exam_plan_data.end_date) || "-" }}
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <v-card outlined class="mb-4 add-schedule-card">
                        <v-card-title class="py-2 text-subtitle-1 font-weight-bold">
                            <v-icon small class="mr-2">mdi-calendar-plus</v-icon>
                            Add Subject Wise Schedule
                        </v-card-title>

                        <v-divider></v-divider>

                        <v-card-text class="pt-3">
                            <v-row dense>
                                <v-col cols="12" md="3">
                                    <v-menu v-model="coursewise_date_menu" :close-on-content-click="false" offset-y>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="coursewise_form.date" label="Date" readonly
                                                v-bind="attrs" v-on="on" outlined dense
                                                prepend-inner-icon="mdi-calendar"></v-text-field>
                                        </template>

                                        <v-date-picker v-model="coursewise_form.date" :min="exam_plan_data.start_date"
                                            :max="exam_plan_data.end_date"
                                            @input="coursewise_date_menu = false; coursewiseDateChanged()"></v-date-picker>
                                    </v-menu>
                                </v-col>

                                <v-col cols="12" md="2">
                                    <v-text-field :value="getDayName(coursewise_form.date)" label="Day" readonly
                                        outlined dense></v-text-field>
                                </v-col>

                                <v-col cols="12" md="2">
                                    <v-select v-model="coursewise_form.eds_id" :items="coursewise_slot_list"
                                        item-text="slot_number" item-value="eds_id" label="Slot No." outlined dense
                                        @change="coursewiseSlotChanged"></v-select>
                                </v-col>

                                <v-col cols="12" md="2">
                                    <v-text-field :value="selectedCoursewiseSlot.start_time" label="From Time" readonly
                                        outlined dense></v-text-field>
                                </v-col>

                                <v-col cols="12" md="2">
                                    <v-text-field :value="selectedCoursewiseSlot.end_time" label="To Time" readonly
                                        outlined dense></v-text-field>
                                </v-col>

                                <v-col cols="12" md="1">
                                    <v-text-field :value="exam_plan_data.conduct_type" label="Conduct" readonly outlined
                                        dense></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row dense>
                                <v-col cols="12" md="3">
                                    <v-select v-model="coursewise_form.stream_id" :items="exam_stream_list"
                                        item-text="name" item-value="id" label="Stream" outlined dense></v-select>
                                </v-col>

                                <v-col cols="12" md="3">
                                    <v-select v-model="coursewise_form.standard_id" :items="exam_standard_list"
                                        item-text="name" item-value="id" label="Standard" outlined dense
                                        @change="coursewiseStandardChanged"></v-select>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-select v-model="coursewise_form.course_offering_id" :items="course_list"
                                        item-text="course" item-value="id" label="Subject" outlined dense></v-select>
                                </v-col>

                                <v-col cols="12" md="1">
                                    <v-btn color="success" block depressed :loading="saveCoursewiseScheduleLoader"
                                        @click="saveExamCoursewiseSchedule">
                                        Save
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card outlined class="schedule-list-card">
                        <v-card-title class="py-2">
                            <div>
                                <div class="text-subtitle-1 font-weight-bold">
                                    <v-icon small class="mr-2">mdi-calendar-clock</v-icon>
                                    Scheduled Subjects
                                </div>
                                <div class="caption grey--text">
                                    {{ coursewise_schedule_list.length }} schedule(s)
                                </div>
                            </div>

                            <v-spacer></v-spacer>

                            <v-chip small outlined color="primary">
                                {{ coursewise_schedule_list.length }}
                            </v-chip>
                        </v-card-title>

                        <v-divider></v-divider>

                        <div class="schedule-table-wrapper">
                            <v-data-table :headers="coursewise_headers" :items="coursewise_schedule_list"
                                :loading="coursewise_loading" dense fixed-header height="350px"
                                class="coursewise-table">
                                <template v-slot:item.exam_date="{ item }">
                                    {{ formatCoursewiseDate(item.exam_date) }}
                                </template>

                                <template v-slot:item.actions="{ item }">
                                    <v-btn icon small color="primary" @click="editExamCoursewiseSchedule(item)">
                                        <v-icon small>mdi-pencil</v-icon>
                                    </v-btn>

                                    <v-btn icon small color="error" @click="deleteExamCoursewiseSchedule(item)">
                                        <v-icon small>mdi-delete</v-icon>
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </div>
                    </v-card>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="edit_coursewise_dialog" max-width="1000px" persistent>
            <v-card>
                <v-card-title class="py-2">
                    <span class="text-h6">Edit Subject Wise Exam Schedule</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="edit_coursewise_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-3">
                    <v-row dense>
                        <v-col cols="12" md="3">
                            <v-menu v-model="editCoursewiseDateMenu" :close-on-content-click="false" offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="editCoursewiseForm.date" label="Date" readonly outlined dense
                                        v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="editCoursewiseForm.date" :min="exam_plan_data.start_date"
                                    :max="exam_plan_data.end_date"
                                    @input="editCoursewiseDateMenu = false; editCoursewiseDateChanged()"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field :value="getDayName(editCoursewiseForm.date)" label="Day" readonly outlined
                                dense></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-select v-model="editCoursewiseForm.eds_id" :items="editCoursewiseSlotList"
                                item-text="slot_number" item-value="eds_id" label="Slot No." outlined dense
                                @change="editCoursewiseSlotChanged"></v-select>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field :value="editCoursewiseSelectedSlot.start_time" label="From Time" readonly
                                outlined dense></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field :value="editCoursewiseSelectedSlot.end_time" label="To Time" readonly outlined
                                dense></v-text-field>
                        </v-col>
                        <v-col cols="12" md="1">
                            <v-text-field v-model="exam_plan_data.conduct_type" label="Conduct" readonly outlined
                                dense></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" md="3">
                            <v-select v-model="editCoursewiseForm.stream_id" :items="exam_stream_list" item-text="name"
                                item-value="id" label="Stream" outlined dense></v-select>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-select v-model="editCoursewiseForm.standard_id" :items="exam_standard_list"
                                item-text="name" item-value="id" label="Standard" outlined dense
                                @change="editCoursewiseStandardChanged"></v-select>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-select v-model="editCoursewiseForm.course_id" :items="course_list" item-text="course"
                                item-value="id" label="Subject" outlined dense>
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-btn color="primary" block :loading="editCoursewiseScheduleLoader"
                                @click="updateExamCoursewiseSchedule">
                                Update
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="view_coursewise_dialog" max-width="1200px" persistent>
            <v-card>

                <v-card-title class="primary white--text">
                    <span class="text-h6">
                        Subject Wise Exam Schedule
                    </span>

                    <v-spacer></v-spacer>

                    <v-btn icon dark @click="view_coursewise_dialog = false">
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>

                    <v-row class="mt-2">
                        <v-col cols="12" md="3">
                            <b>Exam Plan:</b>
                            {{ view_coursewise_exam_plan.exam_name || '-' }}
                        </v-col>
                        <v-col cols="12" md="3">
                            <b>Academic Year:</b>
                            {{ view_coursewise_exam_plan.academicyear || '-' }}
                        </v-col>
                        <v-col cols="12" md="3">
                            <b>Semester:</b>
                            {{ view_coursewise_exam_plan.semester || '-' }}
                        </v-col>
                        <v-col cols="12" md="3">
                            <b>Conduct Type:</b>
                            {{ view_coursewise_exam_plan.exam_conduct_type || '-' }}
                        </v-col>

                    </v-row>

                    <v-divider class="my-3"></v-divider>

                    <v-overlay :value="view_coursewise_loader">
                        <v-progress-circular indeterminate size="40"></v-progress-circular>
                    </v-overlay>

                    <v-data-table :headers="view_coursewise_headers" :items="coursewise_schedule_list"
                        :loading="view_coursewise_loader" dense outlined :items-per-page="10">

                        <template v-slot:item.sr_no="{ item }">
                            {{ item.sr_no }}
                        </template>

                        <template v-slot:item.exam_date="{ item }">
                            {{ item.exam_date }}
                        </template>

                        <template v-slot:item.day="{ item }">
                            {{ item.day || '-' }}
                        </template>

                        <template v-slot:item.slot_number="{ item }">
                            {{ item.slot_number || '-' }}
                        </template>

                        <template v-slot:item.start_time="{ item }">
                            {{ item.start_time || '-' }}
                        </template>

                        <template v-slot:item.end_time="{ item }">
                            {{ item.end_time || '-' }}
                        </template>

                        <template v-slot:item.subject_code="{ item }">
                            {{ item.subject_code || '-' }}
                        </template>

                        <template v-slot:item.subject="{ item }">
                            {{ item.subject || '-' }}
                        </template>

                        <template v-slot:item.standard="{ item }">
                            {{ item.standard || '-' }}
                        </template>

                        <template v-slot:item.stream="{ item }">
                            {{ item.stream || '-' }}
                        </template>

                        <template v-slot:no-data>
                            No Subject Wise Exam Schedule found.
                        </template>

                    </v-data-table>

                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="primary" text @click="view_coursewise_dialog = false">
                        Close
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
        <v-dialog v-model="seating_view_dialog" max-width="1400px">
            <v-card>

                <v-toolbar dense flat class="toolbar">
                    <v-toolbar-title>
                        <strong>
                            Seating Arrangement
                        </strong>
                    </v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn icon small @click="seating_view_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="12" m="12">
                            <v-data-table :headers="seating_view_headers" :items="seating_view_list" dense
                                class="elevation-1" :loading="view_seating_loader"
                                no-data-text="No Seating Arrangement found.">

                                <template v-slot:item.is_absent="{ item }">
                                    <v-chip x-small :color="item.is_absent ? 'red' : 'green'" dark>
                                        {{ item.is_absent ? 'Yes' : 'No' }}
                                    </v-chip>
                                </template>

                            </v-data-table>
                        </v-col>
                    </v-row>


                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="primary" small @click="seating_view_dialog = false">
                        Close
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
import "jspdf-autotable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            overlay: false,
            selected: [],
            snackbar: false,
            search: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_std_div_list: null,
            sel_ay_data: null,
            selAyData: null,
            std_div_list: null,
            sel_std_data: null,
            div_list: null,
            div: null,
            semester_list: [],
            sem: null,
            sel_sem: null,
            fetch_loader: false,
            get_loader: false,
            assessment_detail_list: [],
            assessment_detail: null,
            standard: null,
            course: null,
            ass_Scheme: null,
            academicyear: null,
            ass_detail_list: null,
            org_basic_data: [],
            date1: new Date().toISOString().substr(0, 10),
            date2: new Date().toISOString().substr(0, 10),
            menu1: false,
            menu2: false,
            new_from_date: null,
            new_to_date: null,
            menu3: false,
            menu4: false,
            exam_crs_slot: null,
            exam_crs_std: null,
            crs_id: null,
            timeSlotCount: null,
            timeSlots: [],
            exam_name: null,
            exam_plan_list: [],
            dialog_add: false,
            exam_plan_data: null,
            exam_plan_id: null,
            crs_list: [],
            exam_crs_sechedule_list: [],
            filterArr: [],
            delete_dailog: false,
            filters: {
                ecs_standard: [],
                ecs_day: [],
                ecs_exam_date: [],
                ecs_from_time: [],
                ecs_to_time: [],
            },
            headers_crs: [
                { text: "Sr. No.", value: "sr_no" },
                { text: "Exam Name", value: "ecs_examplan" },
                { text: "Standard", value: "ecs_standard" },
                { text: "Course", value: "ecs_course" },
                { text: "Exam Date", value: "ecs_exam_date" },
                { text: "Day", value: "ecs_day" },
                { text: "From Time", value: "ecs_from_time" },
                { text: "To Time", value: "ecs_to_time" },
            ],
            headers: [
                { text: "Sr. No.", value: "sr_no" },
                { text: "Exam Name", value: "exam_name" },
                // { text: "Plan Name", value: "plan_name" },
                { text: "Assessmenttype", value: "assessmenttype" },
                { text: "Exam Slot", value: "maximum_number_of_slots_in_day" },
                { text: "Subjectwise Schedule", value: "subjectwise_schedule" },
                { text: "Assign Bench Side", value: "assign_bench_side" },
                { text: "Offer Room", value: "offer_room" },
                { text: "Start Date", value: "start_date" },
                { text: "End Date", value: "end_date" },
                { text: "Seating Arrangement", value: "seating_arrangement" },
                { text: "Is Approved ?", value: "isApproved" },
                { text: "Is Current ?", value: "isCurrent" },
                { text: "Is Freezed ?", value: "is_seating_arrangment_freezed" },
                { text: "Is Supervisor Enabled ?", value: "supervisor_enabled" },
                { text: "Allow auto bench allocation ?", value: "benchwise_allocation" },
                { text: "Exam Conduct Type", value: "exam_conduct_type" },
                { text: "Stream", value: "stream" },
                { text: "Standard", value: "ep_std_name" },
                { text: "Door Display Report", value: "door_display_report" },
                { text: "Supervisor Report", value: "supervisor_report" },
                { text: "Student Attendance Report", value: "student_attendance_report" },
                { text: "Room Utilization Report", value: "room_utilization_report" },
                // { text: "Max. Number Of Slots In Day", value: "maximum_number_of_slots_in_day" },
                { text: "Academic Year", value: "academicyear" },
                { text: "Semester", value: "semester" },
                // { text: "Add Course Schedule", value: "add_crs_schedule" },
                { text: "Edit", value: "edit" },
                { text: "Delete", value: "delete" },
            ],
            examPlanDialog: false,
            exam_conduct_type: [],
            exam_conduct_type_selected: 1,
            stream_list: [],
            stream: [],
            supervisor_enabled: false,
            benchwise_allocation: false,
            addExamSlotDialog: false,
            selectedExamPlan: null,
            showAddSlotForm: false,
            slot_loader: false,
            examSlotList: [],
            newSlot: {
                slot_no: null,
                from_time: null,
                to_time: null,
                menuFrom: false,
                menuTo: false
            },
            editExamSlotDialog: false,
            deleteExamSlotDialog: false,

            edit_slot_loader: false,
            delete_slot_loader: false,

            selectedDeleteSlot: null,

            editSlot: {
                id: null,
                slot_no: null,
                from_time: null,
                to_time: null,
                menuFrom: false,
                menuTo: false
            },
            assignBenchSideDialog: false,

            selectedBenchSideExamPlan: null,

            benchSideList: [],
            bench_side_list: [],
            benchSideStreamList: [],
            benchSideStandardList: [],

            selectedBenchSide: null,

            benchSideForm: {
                stream_id: null,
                standard_id: null,
                bench_side_id: null
            },

            benchSideLoader: false,
            saveBenchSideLoader: false,
            benchSideHeaders: [
                {
                    text: "Sr. No.",
                    value: "sr_no",
                    sortable: false
                },
                {
                    text: "Stream",
                    value: "stream"
                },
                {
                    text: "Standard",
                    value: "standard"
                },
                {
                    text: "Bench Side",
                    value: "bench_side"
                },
                {
                    text: "Action",
                    value: "action",
                    sortable: false
                }
            ],
            editBenchSideDialog: false,

            editBenchSideForm: {
                id: null,
                exam_plan_id: null,
                stream_id: null,
                standard_id: null,
                bench_side_id: null
            },

            editBenchSideLoader: false,

            offerRoomDialog: false,

            selectedOfferRoomExamPlan: null,

            roomTypeList: [],
            roomList: [],

            offerRoomForm: {
                room_type_id: null,
                room_id: null,
                number_of_benches: null,
                capacity_per_bench: null
            },

            offerRoomList: [],

            offerRoomLoader: false,
            saveOfferRoomLoader: false,
            roomTypeLoader: false,
            roomLoader: false,

            offerRoomHeaders: [
                {
                    text: "Sr. No.",
                    value: "sr_no",
                    sortable: false
                },
                {
                    text: "Room Type",
                    value: "room_type"
                },
                {
                    text: "Room No",
                    value: "room_no"
                },
                {
                    text: "Number of Benches",
                    value: "number_of_benches"
                },
                {
                    text: "Capacity Per Bench",
                    value: "capacity_per_bench"
                },
                {
                    text: "Total Capacity",
                    value: "total_capacity"
                },
                {
                    text: "Allocated Benches",
                    value: "allocated_benches"
                },
                {
                    text: "Action",
                    value: "action",
                    sortable: false
                }
            ],
            editOfferRoomDialog: false,
            editOfferRoomLoader: false,
            selectedEditOfferRoom: null,

            editOfferRoomForm: {
                number_of_benches: null,
                capacity_per_bench: null
            },
            allocatedBenchDialog: false,
            selectedAllocatedBenchOffering: null,

            allocatedBenchList: [],
            benchSideList: [],

            allocatedBenchLoader: false,
            saveAllocatedBenchLoader: false,
            benchSideLoader: false,
            allocatedBenchHeaders: [
                { text: "Sr. No.", value: "sr_no", sortable: false },
                { text: "Bench Number", value: "bench_number" },
                { text: "Bench Side", value: "bench_side" },
                { text: "Action", value: "action", sortable: false }
            ],
            editExamPlanDialog: false,
            editExamPlanLoader: false,
            deleteExamPlanLoader: false,

            editExamPlan: {
                plan_id: null,
                exam_name: null,
                assessment_type_id: null,
                exam_conduct_type_id: null,
                supervisor_enabled: false,
                benchwise_allocation: false,
                start_date: null,
                end_date: null
            },
            delete_loader: false,
            exam_coursewise_dialog: false,
            exam_plan_data: {},
            exam_stream_list: [],
            exam_standard_list: [],
            exam_detailed_schedule_list: [],
            coursewise_schedule_list: [],
            coursewise_loading: false,
            coursewise_form: {
                date: null,
                eds_id: null,
                stream_id: null,
                standard_id: null,
                course_offering_id: null
            },
            coursewise_slot_list: [],
            course_list: [],
            coursewise_date_menu: false,
            selectedCoursewiseSlot: {},
            coursewise_headers: [
                { text: "Sr. No.", value: "sr_no" },
                { text: "Date", value: "exam_date" },
                { text: "Day", value: "day" },
                { text: "Slot", value: "slot_number" },
                { text: "Start Time", value: "start_time", sortable: false },
                { text: "End Time", value: "end_time", sortable: false },
                { text: "Subject Code", value: "subject_code" },
                { text: "Subject Name", value: "subject" },
                { text: "Standard", value: "standard" },
                { text: "Stream", value: "stream" },
                { text: "Conduct Type", value: "conduct_type" },
                { text: "Exam Plan", value: "exam_plan" },
                { text: "Academic Year", value: "academic_year" },
                { text: "Semester", value: "semester" },
                { text: "Actions", value: "actions", sortable: false }
            ],
            saveCoursewiseScheduleLoader: false,
            edit_coursewise_dialog: false,
            editCoursewiseScheduleLoader: false,
            editCoursewiseDateMenu: false,
            editCoursewiseSlotList: [],
            editCoursewiseSubjectList: [],
            editCoursewiseSelectedSlot: {},
            editCoursewiseForm: {
                id: null,
                date: null,
                eds_id: null,
                stream_id: null,
                standard_id: null,
                course_id: null
            },
            view_coursewise_dialog: false,
            view_coursewise_loader: false,
            view_coursewise_exam_plan: {},
            view_coursewise_headers: [
                {
                    text: "Sr. No.",
                    value: "sr_no",
                    sortable: false
                },
                {
                    text: "Date",
                    value: "exam_date"
                },
                {
                    text: "Day",
                    value: "day"
                },
                {
                    text: "Slot",
                    value: "slot_number"
                },
                {
                    text: "From",
                    value: "start_time"
                },
                {
                    text: "To",
                    value: "end_time"
                },
                {
                    text: "Subject Code",
                    value: "subject_code"
                },
                {
                    text: "Subject",
                    value: "subject"
                },
                {
                    text: "Standard",
                    value: "standard"
                },
                {
                    text: "Stream",
                    value: "stream"
                }
            ],
            selected_all_benches: false,

            allocatedBenchForm: {
                bench_numbers: [],
                bench_side_id: null
            },
            seating_view_dialog: false,
            seating_view_list: [],
            seating_view_exam_plan: null,
            view_seating_loader: false,
            seating_view_headers: [
                { text: "Sr. No.", value: "sr_no" },
                { text: "Exam Date", value: "exam_date" },
                { text: "Day", value: "exam_day" },
                { text: "Slot", value: "slot_number" },
                { text: "Time", value: "time" },
                { text: "Subject Code", value: "subject_code" },
                { text: "Subject", value: "subject_name" },
                { text: "Standard", value: "standard" },
                { text: "Stream", value: "stream" },
                { text: "Student", value: "student_name" },
                { text: "Room", value: "room_name" },
                { text: "Bench", value: "bench_number" },
                { text: "Bench Side", value: "bench_side" },
                { text: "Supervisor", value: "supervisor" },
                { text: "Absent", value: "is_absent" }
            ],
            editStartDateMenu: false,
            editEndDateMenu: false,
        };
    },
    computed: {
        bookList1() {
            return this.exam_crs_sechedule_list.filter((d) => {
                return Object.keys(this.filters).every((f) => {
                    return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                });
            });
        },

        offerRoomTotalCapacity() {
            const benches = Number(this.offerRoomForm.number_of_benches || 0);
            const capacity = Number(this.offerRoomForm.capacity_per_bench || 0);
            return benches * capacity;
        },

        editOfferRoomTotalCapacity() {
            const benches = Number(this.editOfferRoomForm.number_of_benches || 0);
            const capacity = Number(this.editOfferRoomForm.capacity_per_bench || 0);
            return benches * capacity;
        },
        availableBenchNumbers() {
            if (!this.selectedAllocatedBenchOffering) {
                return [];
            }
            const totalBenches = Number(
                this.selectedAllocatedBenchOffering.number_of_benches || 0
            );
            return Array.from(
                { length: totalBenches },
                (_, index) => index + 1
            );
        }
    },
    watch: {
        date1(val) {
            this.new_from_date = this.formatDate(this.date1);
        },
        date2(val) {
            this.new_to_date = this.formatDate(this.date2);
        },
        'allocatedBenchForm.bench_numbers': function (val) {
            val = val || []

            if (val.length > 0) {
                // ...
            }
        }
    },

    methods: {
        closeCoursewiseDialog() {
            this.exam_coursewise_dialog = false;
            this.resetCoursewiseForm();
        },
        resetCoursewiseForm() {
            this.coursewise_form = {
                date: null,
                eds_id: null,
                stream_id: null,
                standard_id: null,
                course_offering_id: null
            };
            this.course_list = [];
            this.selectedCoursewiseSlot = {};
            this.coursewise_slot_list = [];
            this.coursewise_subject_list = [];
        },
        toggleSelectAllBenches() {
            if (this.selected_all_benches) {
                this.selected_all_benches = false;
                this.allocatedBenchForm.bench_numbers = [];
            } else {
                this.selected_all_benches = true;
                this.allocatedBenchForm.bench_numbers = [...this.availableBenchNumbers];
            }
        },
        async viewExamCoursewiseSchedule(item) {
            this.view_coursewise_exam_plan = item;
            this.view_coursewise_dialog = true;
            this.view_coursewise_loader = true;

            try {
                await this.getExamCoursewiseScheduleData(item.plan_id);
            } catch (error) {
            } finally {
                this.view_coursewise_loader = false;
            }
        },
        async viewSeatingArrangement(item) {
            this.seating_view_dialog = true;
            this.seating_view_list = [];
            this.seating_view_exam_plan = item;
            this.view_seating_loader = true;

            try {
                await this.getSeatingArrangementReport(item.plan_id, true);
            } catch (error) {
            } finally {
                this.view_seating_loader = false;
            }
        },
        getSeatingArrangementReport(ExamPlan = null, isView = false) {
            const selectedExamPlan = ExamPlan || this.exam_plan;

            if (!selectedExamPlan) {
                this.seating_arrangement_list = [];
                return Promise.resolve();
            }

            const data = {
                exam_plan: selectedExamPlan,
                conduct_type: isView ? [] : this.conduct_type,
                stream: isView ? [] : this.stream,
                standard: isView ? [] : this.standard,
                subject: isView ? [] : this.subject,
                room: isView ? [] : this.room,
                student: isView ? [] : this.student,
                supervisor: isView ? [] : this.supervisor
            };


            this.overlay = true;

            return axios.post("/SeatingArrangement/getSeatingArrangementReportData", data)
                .then((res) => {
                    if (res.data.msg == "200") {

                        const list = res.data.seating_arrangement_list || [];

                        if (isView) {
                            this.seating_view_list = list.map((item, index) => {
                                item.sr_no = index + 1;
                                return item;
                            });
                        } else {
                            this.seating_arrangement_list = list.map((item, index) => {
                                item.sr_no = index + 1;
                                return item;
                            });
                        }

                    } else {
                        if (isView) {
                            this.seating_view_list = [];
                        } else {
                            this.seating_arrangement_list = [];
                        }

                        this.showSnackbar(
                            "#b71c1c",
                            res.data.text || "Unable to fetch Seating Arrangement."
                        );
                    }
                })
                .catch((error) => {
                    if (isView) {
                        this.seating_view_list = [];
                    } else {
                        this.seating_arrangement_list = [];
                    }

                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        async deleteExamCoursewiseSchedule(item) {
            if (!confirm("Are you sure you want to delete this Subject Wise Exam Schedule?")) {
                return;
            }

            const data = {
                id: item.id
            };

            try {
                this.loading = true;

                const res = await axios.post(
                    "/SeatingArrangement/deleteExamCoursewiseSchedule",
                    data
                );

                if (res.data.flag == "YES") {
                    this.snackbar_msg =
                        res.data.msg ||
                        "Subject Wise Exam Schedule deleted successfully.";
                    this.color = "success";
                    this.snackbar = true;

                    await this.getExamCoursewiseScheduleData(
                        this.exam_plan_data.id
                    );
                } else {
                    this.snackbar_msg =
                        res.data.msg ||
                        "Unable to delete Subject Wise Exam Schedule.";
                    this.color = "error";
                    this.snackbar = true;

                    if (res.data.error_trace) {
                        sessionStorage.setItem(
                            "error-trace",
                            res.data.error_trace
                        );
                    }
                }

            } catch (err) {
                this.onerror(err);
            } finally {
                this.loading = false;
            }
        },
        viewDetails(item) {
            localStorage.setItem("exam_plan", item.plan_id);
            localStorage.setItem("ay", this.sel_ay_data.ay_id);

            const routeData = this.$router.resolve({
                name: "exam-plan-details"
            });

            window.open(routeData.href, "_blank");
        },
        openSeatingArrangement(item) {
            localStorage.setItem("exam_plan", item.plan_id);
            localStorage.setItem("ay", this.sel_ay_data.ay_id);

            const routeData = this.$router.resolve({
                name: "seating-arrangement-report"
            });

            window.open(routeData.href, "_blank");
        },
        openDoorDisplayReport(item) {
            localStorage.setItem("exam_plan", item.plan_id);
            localStorage.setItem("ay", this.sel_ay_data.ay_id);

            const routeData = this.$router.resolve({
                name: "door-display-report"
            });

            window.open(routeData.href, "_blank");
        },
        openSupervisorReport(item) {
            localStorage.setItem("exam_plan", item.plan_id);
            localStorage.setItem("ay", this.sel_ay_data.ay_id);

            const routeData = this.$router.resolve({
                name: "supervisor-report"
            });

            window.open(routeData.href, "_blank");
        },
        openStudentAttendanceReport(item) {
            localStorage.setItem("exam_plan", item.plan_id);
            localStorage.setItem("ay", this.sel_ay_data.ay_id);

            const routeData = this.$router.resolve({
                name: "student-attendance-report"
            });

            window.open(routeData.href, "_blank");
        },
        openRoomUtilizationReport(item) {
            localStorage.setItem("exam_plan", item.plan_id);
            localStorage.setItem("ay", this.sel_ay_data.ay_id);

            const routeData = this.$router.resolve({
                name: "room-utilization-report"
            });

            window.open(routeData.href, "_blank");
        },
        async editExamCoursewiseSchedule(item) {
            this.edit_coursewise_dialog = true;
            this.editCoursewiseScheduleLoader = true;

            this.editCoursewiseForm = {
                id: item.id,
                date: item.exam_date,
                eds_id: null,
                stream_id: item.stream_id,
                standard_id: item.standard_id,
                course_id: item.course_id
            };

            this.editCoursewiseSelectedSlot = {};
            this.editCoursewiseSlotList = [];
            this.course_list = [];

            this.editCoursewiseSlotList = this.exam_detailed_schedule_list.filter(
                x => String(x.exam_date) == String(item.exam_date)
            );

            this.editCoursewiseSelectedSlot = this.editCoursewiseSlotList.find(
                x => String(x.slot_number) == String(item.slot_number)
            ) || {};

            this.editCoursewiseForm.eds_id = this.editCoursewiseSelectedSlot.eds_id || null;

            await this.coursewiseStandardChanged(
                item.standard_id,
                true
            );

            this.editCoursewiseScheduleLoader = false;
        },
        getEditCoursewiseSlots() {
            if (!this.editCoursewiseForm.date) {
                this.editCoursewiseSlotList = [];
                return;
            }

            this.editCoursewiseSlotList = this.exam_detailed_schedule_list.filter(
                x => String(x.exam_date) == String(this.editCoursewiseForm.date)
            );

            this.editCoursewiseSelectedSlot =
                this.editCoursewiseSlotList.find(
                    x => String(x.eds_id) == String(this.editCoursewiseForm.eds_id)
                ) || {};
        },
        editCoursewiseDateChanged() {
            this.editCoursewiseForm.eds_id = null;
            this.editCoursewiseSelectedSlot = {};
            this.getEditCoursewiseSlots();
        },
        editCoursewiseSlotChanged() {
            this.editCoursewiseSelectedSlot =
                this.editCoursewiseSlotList.find(
                    x => String(x.eds_id) == String(this.editCoursewiseForm.eds_id)
                ) || {};
        },
        async editCoursewiseStandardChanged() {
            this.editCoursewiseForm.course_id = null;
            this.course_list = [];

            await this.coursewiseStandardChanged(
                this.editCoursewiseForm.standard_id,
                true
            );
        },
        async updateExamCoursewiseSchedule() {
            if (!this.editCoursewiseForm.date) {
                this.snackbar_msg = "Please select Date.";
                this.color = "error";
                this.snackbar = true;
                return;
            }

            if (!this.editCoursewiseForm.eds_id) {
                this.snackbar_msg = "Please select Slot.";
                this.color = "error";
                this.snackbar = true;
                return;
            }

            if (!this.editCoursewiseForm.stream_id) {
                this.snackbar_msg = "Please select Stream.";
                this.color = "error";
                this.snackbar = true;
                return;
            }

            if (!this.editCoursewiseForm.standard_id) {
                this.snackbar_msg = "Please select Standard.";
                this.color = "error";
                this.snackbar = true;
                return;
            }

            if (!this.editCoursewiseForm.course_id) {
                this.snackbar_msg = "Please select Subject.";
                this.color = "error";
                this.snackbar = true;
                return;
            }

            const selectedId = this.editCoursewiseForm.id;
            const selectedSubject = this.editCoursewiseForm.course_id;
            const selectedStandard = this.editCoursewiseForm.standard_id;
            const selectedStream = this.editCoursewiseForm.stream_id;
            const selectedSlot = this.editCoursewiseForm.eds_id;

            const selectedSchedule = this.exam_detailed_schedule_list.find(
                slot => slot.eds_id == selectedSlot
            );

            // RULE 1:
            // Same Date + Slot + Standard + Stream cannot have another subject.
            const sameSession = this.coursewise_schedule_list.find(item =>
                item.id != selectedId &&
                item.slot_number == selectedSchedule.slot_number &&
                item.exam_date == this.editCoursewiseForm.date &&
                item.standard_id == selectedStandard &&
                item.stream_id == selectedStream
            );

            if (sameSession) {
                this.snackbar_msg =
                    "A subject is already scheduled for the selected Date, Slot, Standard and Stream.";
                this.color = "error";
                this.snackbar = true;
                return;
            }

            // RULE 2:
            // Same Standard + Stream + Subject can be scheduled only once
            // in the entire Exam Plan.
            const sameSubject = this.coursewise_schedule_list.find(item =>
                item.id != selectedId &&
                item.standard_id == selectedStandard &&
                item.stream_id == selectedStream &&
                item.course_offering_id == selectedSubject
            );

            if (sameSubject) {
                this.snackbar_msg =
                    "This Subject is already scheduled for the selected Standard and Stream in this Exam Plan.";
                this.color = "error";
                this.snackbar = true;
                return;
            }

            const data = {
                id: this.editCoursewiseForm.id,
                exam_plan_id: this.exam_plan_data.id,
                exam_detailed_schedule_id: this.editCoursewiseForm.eds_id,
                stream_id: this.editCoursewiseForm.stream_id,
                standard_id: this.editCoursewiseForm.standard_id,
                course_id: this.editCoursewiseForm.course_id
            };

            try {
                this.editCoursewiseScheduleLoader = true;

                const res = await axios.post(
                    "/SeatingArrangement/updateExamCoursewiseSchedule",
                    data
                );

                if (res.data.flag == "YES") {
                    this.snackbar_msg =
                        res.data.msg ||
                        "Subject Wise Exam Schedule updated successfully.";

                    this.color = "success";
                    this.snackbar = true;

                    await this.getExamCoursewiseScheduleData(
                        this.exam_plan_data.id
                    );

                    this.edit_coursewise_dialog = false;

                } else {
                    this.snackbar_msg =
                        res.data.msg ||
                        "Unable to update Subject Wise Exam Schedule.";

                    this.color = "error";
                    this.snackbar = true;

                    if (res.data.error_trace) {
                        sessionStorage.setItem(
                            "error-trace",
                            res.data.error_trace
                        );
                    }
                }

            } catch (err) {
                this.onerror(err);

            } finally {
                this.editCoursewiseScheduleLoader = false;
            }
        },
        async coursewiseStandardChanged(standardId, isEdit = false) {
            const standard = standardId || (
                isEdit
                    ? this.editCoursewiseForm.standard_id
                    : this.coursewise_form.standard_id
            );

            if (!standard) {
                this.course_list = [];
                return;
            }

            const data = {
                standard: standard
            };

            try {
                const res = await axios.post(
                    "/BookReview/getCourseOfferingsBystd",
                    data
                );

                this.course_list = (res.data.course_list || []).filter(
                    x => x.id != null
                );

            } catch (error) {
                this.course_list = [];
                this.showSnackbar("#b71c1c", "Something went wrong!!!");
            }
        },
        async saveExamCoursewiseSchedule() {
            if (!this.coursewise_form.date) {
                this.showSnackbar("#b71c1c", "Please select Date.");
                return;
            }

            if (!this.coursewise_form.eds_id) {
                this.showSnackbar("#b71c1c", "Please select Slot.");
                return;
            }

            if (!this.coursewise_form.stream_id) {
                this.showSnackbar("#b71c1c", "Please select stream.");
                return;
            }

            if (!this.coursewise_form.standard_id) {
                this.showSnackbar("#b71c1c", "Please select standard.");
                return;
            }

            if (!this.coursewise_form.course_offering_id) {
                this.showSnackbar("#b71c1c", "Please select subject.");
                return;
            }

            const selectedSubject = this.coursewise_form.course_offering_id;
            const selectedStandard = this.coursewise_form.standard_id;
            const selectedStream = this.coursewise_form.stream_id;
            const selectedSlot = this.coursewise_form.eds_id;

            // RULE 1:
            // Same Date + Slot + Standard + Stream cannot have another subject.
            // const sameSession = this.coursewise_schedule_list.find(item =>
            //     item.slot_number ==
            //     this.exam_detailed_schedule_list.find(
            //         slot => slot.eds_id == selectedSlot
            //     ).slot_number &&
            //     item.exam_date == this.coursewise_form.date &&
            //     item.standard_id == selectedStandard &&
            //     item.stream_id == selectedStream
            // );

            // if (sameSession) {
            //     this.showSnackbar(
            //         "#b71c1c",
            //         "A subject is already scheduled for the selected Date, Slot, Standard and Stream."
            //     );
            //     return;
            // }

            // RULE 2:
            // Same Standard + Stream + Subject can be scheduled only once
            // in the entire Exam Plan.
            const sameSubject = this.coursewise_schedule_list.find(item =>
                item.standard_id == selectedStandard &&
                item.stream_id == selectedStream &&
                item.course_offering_id == selectedSubject
            );

            if (sameSubject) {
                this.showSnackbar(
                    "#b71c1c",
                    "This Subject is already scheduled for the selected Standard and Stream in this Exam Plan."
                );
                return;
            }

            const data = {
                exam_plan_id: this.exam_plan_data.id,
                exam_detailed_schedule_id: this.coursewise_form.eds_id,
                stream_id: this.coursewise_form.stream_id,
                standard_id: this.coursewise_form.standard_id,
                course_offering_id: this.coursewise_form.course_offering_id
            };

            try {
                this.saveCoursewiseScheduleLoader = true;

                const res = await axios.post(
                    "/SeatingArrangement/saveExamCoursewiseSchedule",
                    data
                );

                if (res.data.flag == "YES") {
                    this.snackbar_msg =
                        res.data.msg ||
                        "Subject Wise Exam Schedule saved successfully.";

                    this.color = "success";
                    this.snackbar = true;

                    await this.getExamCoursewiseScheduleData(
                        this.exam_plan_data.id
                    );

                    this.coursewise_form = {
                        date: null,
                        eds_id: null,
                        stream_id: null,
                        standard_id: null,
                        course_offering_id: null
                    };

                    this.selectedCoursewiseSlot = {};
                    this.coursewise_slot_list = [];
                    this.coursewise_subject_list = [];

                } else {
                    this.snackbar_msg =
                        res.data.msg ||
                        "Unable to save Subject Wise Exam Schedule.";

                    this.color = "error";
                    this.snackbar = true;

                    if (res.data.error_trace) {
                        sessionStorage.setItem(
                            "error-trace",
                            res.data.error_trace
                        );
                    }
                }

            } catch (err) {
                this.onerror(err);

            } finally {
                this.saveCoursewiseScheduleLoader = false;
            }
        },
        openExamCoursewiseSchedule(item) {
            this.exam_coursewise_dialog = true
            this.coursewise_loading = true
            this.exam_coursewise_dialog_item = item
            this.getExamCoursewiseScheduleData(item.plan_id)
        },
        async getExamCoursewiseScheduleData(examPlanId) {
            this.coursewise_loading = true;

            try {
                const res = await axios.get(
                    "/SeatingArrangement/getExamCoursewiseScheduleData",
                    {
                        params: {
                            exam_plan_id: examPlanId
                        }
                    }
                );

                if (res.data.flag == "YES") {
                    this.exam_plan_data = res.data.exam_plan;
                    this.exam_stream_list = res.data.stream_list || [];
                    this.exam_standard_list = res.data.standard_list || [];
                    this.exam_detailed_schedule_list =
                        res.data.exam_detailed_schedule_list || [];
                    this.coursewise_schedule_list =
                        res.data.coursewise_schedule_list || [];
                } else {
                    this.showSnackbar("#b71c1c", res.data.msg);
                }

            } catch (err) {
                this.showSnackbar("#b71c1c", "Something went wrong");

            } finally {
                this.coursewise_loading = false;
            }
        },
        formatCoursewiseDate(date) {
            if (!date) return ""
            let p = date.split("-")
            return p[2] + "-" + p[1] + "-" + p[0]
        },
        getDayName(date) {
            if (!date) return ""
            let d = new Date(date + "T00:00:00")
            return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][d.getDay()]
        },
        coursewiseDateChanged() {
            this.coursewise_form.eds_id = null
            this.selectedCoursewiseSlot = {}
            this.getCoursewiseSlots()
        },
        coursewiseSlotChanged() {
            this.selectedCoursewiseSlot = this.coursewise_slot_list.find(x => x.eds_id == this.coursewise_form.eds_id) || {}
        },
        getCoursewiseSlots() {
            if (!this.coursewise_form.date) return

            let list = this.exam_detailed_schedule_list.filter(x => x.exam_date == this.coursewise_form.date)

            this.coursewise_slot_list = list
        },
        openEditExamPlan(item) {
            this.editExamPlan = {
                plan_id: item.plan_id,
                exam_name: item.exam_name,
                assessment_type_id: item.assessment_type_id || null,
                exam_conduct_type_id: item.exam_conduct_type_id || null,
                supervisor_enabled: item.supervisor_enabled == true,
                benchwise_allocation: item.benchwise_allocation == true,
                start_date: this.convertToPickerDate(item.start_date),
                end_date: this.convertToPickerDate(item.end_date),
                has_schedule: item.has_schedule == true
            }
            this.editStartDateMenu = false
            this.editEndDateMenu = false
            this.editExamPlanDialog = true
        },
        convertToPickerDate(date) {
            if (!date) {
                return null
            }

            if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
                return date
            }

            if (/^\d{2}\/[A-Za-z]{3}\/\d{4}$/.test(date)) {
                var parts = date.split("/")
                var day = parts[0]
                var month = parts[1]
                var year = parts[2]

                var months = {
                    Jan: "01",
                    Feb: "02",
                    Mar: "03",
                    Apr: "04",
                    May: "05",
                    Jun: "06",
                    Jul: "07",
                    Aug: "08",
                    Sep: "09",
                    Oct: "10",
                    Nov: "11",
                    Dec: "12"
                }

                return year + "-" + months[month] + "-" + day
            }

            return null
        },
        async updateExamPlan() {
            if (!this.editExamPlan.plan_id) {
                this.showSnackbar("#b71c1c", "Exam plan is not selected.");
                return;
            }

            if (!this.editExamPlan.exam_name) {
                this.showSnackbar("#b71c1c", "Please enter Exam Name.");
                return;
            }

            if (!this.editExamPlan.assessment_type_id) {
                this.showSnackbar("#b71c1c", "Please select Assessment Type.");
                return;
            }

            if (!this.editExamPlan.exam_conduct_type_id) {
                this.showSnackbar("#b71c1c", "Please select Exam Conduct Type.");
                return;
            }

            if (!this.editExamPlan.start_date) {
                this.showSnackbar("#b71c1c", "Please select Start Date.");
                return;
            }

            if (!this.editExamPlan.end_date) {
                this.showSnackbar("#b71c1c", "Please select End Date.");
                return;
            }

            if (this.editExamPlan.start_date > this.editExamPlan.end_date) {
                this.showSnackbar("#b71c1c", "End Date must be greater than or equal to Start Date.");
                return;
            }

            const data = {
                exam_plan_id: this.editExamPlan.plan_id,
                exam_name: this.editExamPlan.exam_name,
                assessment_type_id: this.editExamPlan.assessment_type_id,
                exam_conduct_type_id: this.editExamPlan.exam_conduct_type_id,
                supervisor_enabled: this.editExamPlan.supervisor_enabled,
                benchwise_allocation: this.editExamPlan.benchwise_allocation,
                start_date: this.editExamPlan.start_date,
                end_date: this.editExamPlan.end_date
            };
            try {
                this.editExamPlanLoader = true;
                const res = await axios.post("/SeatingArrangement/updateExamPlan", data);

                if (res.data.flag == "YES") {
                    this.showSnackbar(
                        "#4caf50",
                        res.data.msg ||
                        "Exam Plan updated successfully."
                    );

                    this.editExamPlanDialog = false;

                    await this.getData();

                } else {

                    this.showSnackbar(
                        "#b71c1c",
                        res.data.msg ||
                        "Unable to update Exam Plan."
                    );

                    if (res.data.error_trace) {
                        sessionStorage.setItem(
                            "error-trace",
                            res.data.error_trace
                        );
                    }
                }

            } catch (err) {
                this.onerror(err);

            } finally {

                this.editExamPlanLoader = false;
            }
        },
        async deleteBenchAllocation(item) {
            if (!item || !item.id) {
                return;
            }

            if (!confirm("Are you sure you want to delete this Bench Allocation?")) {
                return;
            }

            const data = {
                exam_room_offering_bench_id: item.id
            };
            try {

                this.offerRoomLoader = true;

                const res = await axios.post(
                    "/SeatingArrangement/deleteExamRoomOfferingBench",
                    data
                );

                if (res.data.flag == "YES") {

                    this.snackbar_msg =
                        res.data.msg ||
                        "Bench Allocation deleted successfully.";

                    this.color = "success";
                    this.snackbar = true;
                    await this.getExamRoomOfferingBenches({
                        id: item.exam_room_offering_id
                    });

                } else {

                    this.snackbar_msg =
                        res.data.msg ||
                        "Unable to delete Bench Allocation.";

                    this.color = "error";
                    this.snackbar = true;

                    if (res.data.error_trace) {
                        sessionStorage.setItem(
                            "error-trace",
                            res.data.error_trace
                        );
                    }
                }

            } catch (err) {
                this.onerror(err);

            } finally {

                this.offerRoomLoader = false;
            }
        },
        async saveAllocatedBench() {
            if (!this.selectedAllocatedBenchOffering) {
                this.snackbar_msg = "Room Offering is required.";
                this.color = "error";
                this.snackbar = true;
                return;
            }

            if (
                !this.allocatedBenchForm.bench_numbers ||
                this.allocatedBenchForm.bench_numbers.length === 0
            ) {
                this.snackbar_msg = "Please select Bench Number(s).";
                this.color = "error";
                this.snackbar = true;
                return;
            }

            if (!this.allocatedBenchForm.bench_side_id) {
                this.snackbar_msg = "Please select Bench Side.";
                this.color = "error";
                this.snackbar = true;
                return;
            }

            const data = {
                exam_room_offering_id:
                    this.selectedAllocatedBenchOffering.exam_room_offering_id ||
                    this.selectedAllocatedBenchOffering.id,

                bench_numbers:
                    this.allocatedBenchForm.bench_numbers.map(Number),

                bench_side_id:
                    this.allocatedBenchForm.bench_side_id
            };
            try {

                this.saveAllocatedBenchLoader = true;

                const res = await axios.post(
                    "/SeatingArrangement/saveExamRoomOfferingBench",
                    data
                );

                if (res.data.flag == "YES") {

                    this.snackbar_msg =
                        res.data.msg ||
                        "Bench(es) allotted successfully.";

                    this.color = "success";
                    this.snackbar = true;

                    await this.getExamRoomOfferingBenches(
                        this.selectedAllocatedBenchOffering
                    );

                    this.allocatedBenchForm = {
                        bench_numbers: [],
                        bench_side_id: null
                    };

                } else {

                    this.snackbar_msg =
                        res.data.msg ||
                        "Unable to allot bench.";

                    this.color = "error";
                    this.snackbar = true;

                    if (res.data.error_trace) {
                        sessionStorage.setItem(
                            "error-trace",
                            res.data.error_trace
                        );
                    }
                }

            } catch (err) {
                this.onerror(err);

            } finally {

                this.saveAllocatedBenchLoader = false;
            }
        },
        async getExamRoomOfferingBenches(item) {

            const data = {
                exam_room_offering_id: item.id
            };

            try {

                this.allocatedBenchLoader = true;

                const res = await axios.post(
                    "/SeatingArrangement/getExamRoomOfferingBenches",
                    data
                );

                if (res.data.flag == "YES") {

                    this.allocatedBenchList =
                        res.data.exam_room_offering_bench_list || [];

                } else {

                    this.allocatedBenchList = [];

                    if (res.data.error_trace) {
                        sessionStorage.setItem(
                            "error-trace",
                            res.data.error_trace
                        );
                    }
                }

            } catch (err) {
                this.onerror(err);

            } finally {

                this.allocatedBenchLoader = false;
            }
        },
        async openAllocatedBenchDialog(item) {
            this.selectedAllocatedBenchOffering = { ...item };

            this.allocatedBenchForm = {
                bench_numbers: null,
                bench_side_id: null
            };

            this.allocatedBenchList = [];
            this.benchSideList = [];

            this.allocatedBenchDialog = true;

            await this.getExamRoomOfferingBenches(item);
            await this.getExamBenchSide();
        },
        editExamRoomOffering(item) {
            this.selectedEditOfferRoom = { ...item };

            this.editOfferRoomForm = {
                number_of_benches: item.number_of_benches,
                capacity_per_bench: item.capacity_per_bench
            };

            this.editOfferRoomDialog = true;
        },
        async updateExamRoomOffering() {
            if (!this.selectedEditOfferRoom) {
                this.snackbar_msg = "Room Offering is required.";
                this.color = "error";
                this.snackbar = true;
                return;
            }

            if (
                !this.editOfferRoomForm.number_of_benches ||
                Number(this.editOfferRoomForm.number_of_benches) <= 0
            ) {
                this.snackbar_msg = "Please enter valid Number of Benches.";
                this.color = "error";
                this.snackbar = true;
                return;
            }

            if (
                !this.editOfferRoomForm.capacity_per_bench ||
                Number(this.editOfferRoomForm.capacity_per_bench) <= 0
            ) {
                this.snackbar_msg = "Please enter valid Capacity Per Bench.";
                this.color = "error";
                this.snackbar = true;
                return;
            }

            const data = {
                exam_room_offering_id: this.selectedEditOfferRoom.id,
                number_of_benches: Number(
                    this.editOfferRoomForm.number_of_benches
                ),
                capacity_per_bench: Number(
                    this.editOfferRoomForm.capacity_per_bench
                )
            };

            try {

                this.editOfferRoomLoader = true;

                const res = await axios.post(
                    "/SeatingArrangement/updateExamRoomOffering",
                    data
                );
                if (res.data.flag == "YES") {
                    this.snackbar_msg = res.data.msg || "Room Offering updated successfully.";
                    this.color = "success";
                    this.snackbar = true;
                    this.editOfferRoomDialog = false;
                    await this.getExamRoomOffering(
                        this.selectedOfferRoomExamPlan
                    );

                } else {

                    this.snackbar_msg = res.data.msg || "Unable to update Room Offering.";
                    this.color = "error";
                    this.snackbar = true;

                    if (res.data.error_trace) {
                        sessionStorage.setItem(
                            "error-trace",
                            res.data.error_trace
                        );
                    }
                }

            } catch (err) {

                this.onerror(err);

            } finally {

                this.editOfferRoomLoader = false;
            }
        },
        async deleteExamRoomOffering(item) {
            if (!item || !item.id) {
                return;
            }

            if (!confirm("Are you sure you want to delete this Room Offering?")) {
                return;
            }

            const data = {
                exam_room_offering_id: item.id
            };
            try {

                this.offerRoomLoader = true;

                const res = await axios.post(
                    "/SeatingArrangement/deleteExamRoomOffering",
                    data
                );
                if (res.data.flag == "YES") {

                    this.snackbar_msg =
                        res.data.msg || "Room Offering deleted successfully.";

                    this.color = "success";
                    this.snackbar = true;

                    await this.getExamRoomOffering(
                        this.selectedOfferRoomExamPlan
                    );

                } else {

                    this.snackbar_msg =
                        res.data.msg || "Unable to delete Room Offering.";

                    this.color = "error";
                    this.snackbar = true;

                    if (res.data.error_trace) {
                        sessionStorage.setItem(
                            "error-trace",
                            res.data.error_trace
                        );
                    }
                }

            } catch (err) {
                this.onerror(err);

            } finally {

                this.offerRoomLoader = false;
            }
        },
        async saveExamRoomOffering() {

            if (!this.selectedOfferRoomExamPlan) {
                this.snackbar_msg = "Exam Plan is required.";
                this.color = "error";
                this.snackbar = true;
                return;
            }

            if (!this.offerRoomForm.room_type_id) {
                this.snackbar_msg = "Please select Room Type.";
                this.color = "error";
                this.snackbar = true;
                return;
            }

            if (!this.offerRoomForm.room_id) {
                this.snackbar_msg = "Please select Room.";
                this.color = "error";
                this.snackbar = true;
                return;
            }

            if (!this.offerRoomForm.number_of_benches || Number(this.offerRoomForm.number_of_benches) <= 0) {
                this.snackbar_msg = "Please enter valid Number of Benches.";
                this.color = "error";
                this.snackbar = true;
                return;
            }

            if (!this.offerRoomForm.capacity_per_bench || Number(this.offerRoomForm.capacity_per_bench) <= 0) {
                this.snackbar_msg = "Please enter valid Capacity Per Bench.";
                this.color = "error";
                this.snackbar = true;
                return;
            }

            const data = {
                exam_plan_id: this.selectedOfferRoomExamPlan.plan_id,
                room_type_id: this.offerRoomForm.room_type_id,
                room_id: this.offerRoomForm.room_id,
                number_of_benches: Number(this.offerRoomForm.number_of_benches),
                capacity_per_bench: Number(this.offerRoomForm.capacity_per_bench)
            };
            try {
                this.saveOfferRoomLoader = true;

                const res = await axios.post(
                    "/SeatingArrangement/saveExamRoomOffering",
                    data
                );
                if (res.data.flag == "YES") {

                    this.snackbar_msg = res.data.msg || "Room offered successfully.";
                    this.color = "success";
                    this.snackbar = true;

                    await this.getExamRoomOffering(
                        this.selectedOfferRoomExamPlan
                    );

                    this.offerRoomForm = {
                        room_type_id: null,
                        room_id: null,
                        number_of_benches: null,
                        capacity_per_bench: null
                    };

                    this.roomList = [];

                } else {

                    this.snackbar_msg = res.data.msg || "Unable to offer room.";
                    this.color = "error";
                    this.snackbar = true;

                    if (res.data.error_trace) {
                        sessionStorage.setItem(
                            "error-trace",
                            res.data.error_trace
                        );
                    }
                }

            } catch (err) {
                this.onerror(err);

            } finally {

                this.saveOfferRoomLoader = false;

            }
        },
        async getRoomTypes() {

            try {

                this.roomTypeLoader = true;

                const res = await axios.post(
                    "/SeatingArrangement/getRoomTypes",
                    {}
                );

                if (res.data.flag == "YES") {

                    this.roomTypeList =
                        res.data.room_type_list || [];

                } else {

                    this.roomTypeList = [];

                    if (res.data.error_trace) {

                        sessionStorage.setItem(
                            "error-trace",
                            res.data.error_trace
                        );
                    }
                }

            } catch (err) {
                this.onerror(err);

            } finally {

                this.roomTypeLoader = false;
            }
        },
        async getRoomsByRoomType() {
            this.roomList = [];

            this.offerRoomForm.room_id = null;
            this.offerRoomForm.capacity_per_bench = null;

            if (!this.offerRoomForm.room_type_id) {
                return;
            }

            const data = {
                room_type_id:
                    this.offerRoomForm.room_type_id
            };

            try {

                this.roomLoader = true;

                const res = await axios.post(
                    "/SeatingArrangement/getRoomsByRoomType",
                    data
                );

                if (res.data.flag == "YES") {

                    this.roomList =
                        res.data.room_list || [];

                } else {

                    this.roomList = [];

                    if (res.data.error_trace) {

                        sessionStorage.setItem(
                            "error-trace",
                            res.data.error_trace
                        );
                    }
                }

            } catch (err) {
                this.onerror(err);

            } finally {

                this.roomLoader = false;
            }
        },
        async getExamRoomOffering(item) {

            const data = {
                exam_plan_id: item.plan_id
            };
            try {

                this.offerRoomLoader = true;

                const res = await axios.post(
                    "/SeatingArrangement/getExamRoomOffering",
                    data
                );
                if (res.data.flag == "YES") {

                    this.offerRoomList =
                        res.data.exam_room_offering_list || [];

                } else {

                    this.offerRoomList = [];

                    if (res.data.error_trace) {

                        sessionStorage.setItem(
                            "error-trace",
                            res.data.error_trace
                        );
                    }
                }

            } catch (err) {
                this.onerror(err);

            } finally {

                this.offerRoomLoader = false;
            }
        },
        async openOfferRoomDialog(item) {

            this.selectedOfferRoomExamPlan = {
                ...item
            };

            this.offerRoomForm = {
                room_type_id: null,
                room_id: null,
                number_of_benches: null,
                capacity_per_bench: null
            };

            this.roomTypeList = [];
            this.roomList = [];
            this.offerRoomList = [];

            this.offerRoomDialog = true;

            await this.getRoomTypes();

            await this.getExamRoomOffering(item);
        },
        async editExamStandardStreamBenchSide(item) {

            this.editBenchSideForm = {
                id: item.id,
                exam_plan_id: item.examplan_id,
                stream_id: item.stream_id,
                stream: item.stream,
                standard_id: item.standard_id,
                standard: item.standard,
                bench_side_id: item.bench_side_id
            };
            await this.getExamBenchSide();

            this.editBenchSideDialog = true;
        },
        async updateExamStandardStreamBenchSide() {

            if (!this.editBenchSideForm.id) {

                this.showSnackbar(
                    "#b71c1c",
                    "Bench side assignment is not selected."
                );

                return;
            }

            if (!this.editBenchSideForm.bench_side_id) {

                this.showSnackbar(
                    "#b71c1c",
                    "Please select bench side."
                );

                return;
            }

            const data = {

                id: this.editBenchSideForm.id,

                exam_plan_id:
                    this.editBenchSideForm.exam_plan_id,

                standard_id:
                    this.editBenchSideForm.standard_id,

                stream_id:
                    this.editBenchSideForm.stream_id,

                bench_side_id:
                    this.editBenchSideForm.bench_side_id
            };
            try {

                this.editBenchSideLoader = true;

                const res = await axios.post(
                    "/SeatingArrangement/updateExamStandardStreamBenchSide",
                    data
                );

                if (res.data.flag == "YES") {

                    this.showSnackbar(
                        "#4caf50",
                        res.data.msg ||
                        "Bench side updated successfully."
                    );

                    this.editBenchSideDialog = false;

                    await this.getExamStandardStreamBenchSide(
                        this.selectedBenchSideExamPlan
                    );

                } else {

                    this.showSnackbar(
                        "#b71c1c",
                        res.data.msg ||
                        "Unable to update bench side."
                    );

                    if (res.data.error_trace) {

                        sessionStorage.setItem(
                            "error-trace",
                            res.data.error_trace
                        );
                    }
                }

            } catch (err) {
                this.onerror(err);

            } finally {

                this.editBenchSideLoader = false;
            }
        },
        async deleteExamStandardStreamBenchSide(item) {

            if (!item || !item.id) {

                this.showSnackbar(
                    "#b71c1c",
                    "Bench side assignment not found."
                );

                return;
            }

            const confirmed = confirm(
                "Are you sure you want to delete bench side assignment for " +
                item.stream +
                " - " +
                item.standard +
                "?"
            );

            if (!confirmed) {
                return;
            }

            const data = {
                id: item.id,
                exam_plan_id: item.examplan_id
            };

            try {

                this.benchSideLoader = true;

                const res = await axios.post(
                    "/SeatingArrangement/deleteExamStandardStreamBenchSide",
                    data
                );

                if (res.data.flag == "YES") {

                    this.showSnackbar(
                        "#4caf50",
                        res.data.msg ||
                        "Bench side deleted successfully."
                    );

                    await this.getExamStandardStreamBenchSide(
                        this.selectedBenchSideExamPlan
                    );

                } else {

                    this.showSnackbar(
                        "#b71c1c",
                        res.data.msg ||
                        "Unable to delete bench side."
                    );

                    if (res.data.error_trace) {

                        sessionStorage.setItem(
                            "error-trace",
                            res.data.error_trace
                        );
                    }
                }

            } catch (err) {
                this.onerror(err);

            } finally {

                this.benchSideLoader = false;
            }
        },
        async saveExamStandardStreamBenchSide() {
            if (!this.selectedBenchSideExamPlan) {
                this.showSnackbar(
                    "#b71c1c",
                    "Exam plan is not selected."
                );
                return;
            }

            if (!this.benchSideForm.standard_id) {
                this.showSnackbar(
                    "#b71c1c",
                    "Please select standard."
                );
                return;
            }

            if (!this.benchSideForm.bench_side_id) {
                this.showSnackbar(
                    "#b71c1c",
                    "Please select bench side."
                );
                return;
            }

            const data = {
                exam_plan_id: this.selectedBenchSideExamPlan.plan_id,
                standard_id: this.benchSideForm.standard_id,
                bench_side_id: this.benchSideForm.bench_side_id,
                stream_id: this.benchSideForm.stream_id
            };

            try {

                this.saveBenchSideLoader = true;

                const res = await axios.post(
                    "/SeatingArrangement/saveExamStandardStreamBenchSide",
                    data
                );

                if (res.data.flag == "YES") {

                    this.showSnackbar(
                        "#4caf50",
                        res.data.msg ||
                        "Bench side assigned successfully."
                    );

                    this.benchSideForm = {
                        stream_id: null,
                        standard_id: null,
                        bench_side_id: null
                    };
                    await this.getExamStandardStreamBenchSide(
                        this.selectedBenchSideExamPlan
                    );

                } else {

                    this.showSnackbar(
                        "#b71c1c",
                        res.data.msg ||
                        "Unable to assign bench side."
                    );

                    if (res.data.error_trace) {
                        sessionStorage.setItem(
                            "error-trace",
                            res.data.error_trace
                        );
                    }
                }

            } catch (err) {
                this.onerror(err);

            } finally {

                this.saveBenchSideLoader = false;

            }
        },
        async openAssignBenchSideDialog(item) {
            this.selectedBenchSideExamPlan = { ...item };

            this.benchSideForm = {
                stream_id: null,
                standard_id: null,
                bench_side_id: null
            };

            this.benchSideStreamList = [];
            this.benchSideStandardList = [];
            this.benchSideList = [];

            if (item.stream_list && item.stream_list.length > 0) {

                this.benchSideStreamList = item.stream_list.map(stream => ({
                    str_id: stream.id,
                    str: stream.name
                }));

            } else {
            }

            if (item.std_list) {

                this.benchSideStandardList = item.std_list;

            } else {
            }

            this.assignBenchSideDialog = true;

            await this.getExamBenchSide();
            await this.getExamStandardStreamBenchSide(item);
        },
        async getExamBenchSide() {
            try {
                const res = await axios.post(
                    "/SeatingArrangement/getExamBenchSide",
                    {}
                );

                if (res.data.active_bench_sides) {
                    this.bench_side_list = res.data.active_bench_sides;
                } else {
                    this.bench_side_list = [];
                }
            } catch (err) {
                this.onerror(err);
            }
        },
        async getExamStandardStreamBenchSide(item) {

            const data = {
                exam_plan_id: item.plan_id
            };

            try {
                this.benchSideLoader = true;

                const res = await axios.post(
                    "/SeatingArrangement/getExamStandardStreamBenchSide",
                    data
                );

                if (res.data.flag == "YES") {
                    this.benchSideList =
                        res.data.exam_bench_side_list || [];
                } else {
                    this.benchSideList = [];
                }

            } catch (err) {
                this.onerror(err);
            } finally {
                this.benchSideLoader = false;
            }
        },
        openEditSlot(slot) {

            this.editSlot = {
                id: slot.id,
                slot_no: slot.slot_number,
                from_time: slot.from_time,
                to_time: slot.to_time,
                menuFrom: false,
                menuTo: false
            };

            this.editExamSlotDialog = true;
        },
        async updateExamSlot() {

            if (!this.selectedExamPlan) {

                this.showSnackbar(
                    "#b71c1c",
                    "Exam plan is not selected."
                );

                return;
            }

            if (
                this.editSlot.slot_no == null ||
                this.editSlot.slot_no == ""
            ) {

                this.showSnackbar(
                    "#b71c1c",
                    "Please enter slot number."
                );

                return;
            }

            if (!this.editSlot.from_time) {

                this.showSnackbar(
                    "#b71c1c",
                    "Please select from time."
                );

                return;
            }

            if (!this.editSlot.to_time) {

                this.showSnackbar(
                    "#b71c1c",
                    "Please select to time."
                );

                return;
            }

            if (this.editSlot.from_time >= this.editSlot.to_time) {

                this.showSnackbar(
                    "#b71c1c",
                    "To time must be greater than from time."
                );

                return;
            }

            const data = {

                exam_plan_id: this.selectedExamPlan.plan_id,

                slot_id: this.editSlot.id,

                slot_no: this.editSlot.slot_no,

                from_time: this.editSlot.from_time,

                to_time: this.editSlot.to_time
            };

            try {

                this.edit_slot_loader = true;

                const res = await axios.post(
                    "/SeatingArrangement/updateExamSlot",
                    data
                );

                if (res.data.flag == "YES") {

                    this.showSnackbar(
                        "#4caf50",
                        "Slot updated successfully."
                    );

                    this.editExamSlotDialog = false;

                    await this.getExamSlots(
                        this.selectedExamPlan
                    );

                    this.getData();

                } else {

                    this.showSnackbar(
                        "#b71c1c",
                        res.data.msg ||
                        res.data.fmsg ||
                        "Unable to update slot."
                    );
                }

            } catch (err) {

                this.onerror(err);

            } finally {

                this.edit_slot_loader = false;
            }
        },
        openDeleteSlot(slot) {

            this.selectedDeleteSlot = slot;

            this.deleteExamSlotDialog = true;
        },
        async deleteExamSlot() {

            if (!this.selectedExamPlan || !this.selectedDeleteSlot) {

                this.showSnackbar(
                    "#b71c1c",
                    "Exam slot is not selected."
                );

                return;
            }

            const data = {

                exam_plan_id:
                    this.selectedExamPlan.plan_id,

                slot_id:
                    this.selectedDeleteSlot.id,

                slot_no:
                    this.selectedDeleteSlot.slot_number
            };

            try {

                this.delete_slot_loader = true;

                const res = await axios.post(
                    "/SeatingArrangement/deleteExamSlot",
                    data
                );

                if (res.data.flag == "YES") {

                    this.showSnackbar(
                        "#4caf50",
                        "Slot deleted successfully."
                    );

                    this.deleteExamSlotDialog = false;

                    this.selectedDeleteSlot = null;

                    await this.getExamSlots(
                        this.selectedExamPlan
                    );
                    await this.getData();
                    this.updateSelectedExamPlan();

                } else {

                    this.showSnackbar(
                        "#b71c1c",
                        res.data.msg ||
                        res.data.fmsg ||
                        "Unable to delete slot."
                    );
                }

            } catch (err) {

                this.onerror(err);

            } finally {

                this.delete_slot_loader = false;
            }
        },
        updateSelectedExamPlan() {
            if (!this.selectedExamPlan) {
                return;
            }

            const updatedPlan = this.exam_plan_list.find(
                plan =>
                    Number(plan.plan_id) ===
                    Number(this.selectedExamPlan.plan_id)
            );

            if (updatedPlan) {
                this.selectedExamPlan = { ...updatedPlan };
            }
        },
        async openExamSlotDialog(item) {
            this.selectedExamPlan = item;
            this.addExamSlotDialog = true;
            this.showAddSlotForm = false;
            this.examSlotList = [];
            this.resetNewSlot();
            await this.getExamSlots(item);
        },
        openExamPlanDialog(item) {
            this.examPlanDialog = true;
        },
        async getExamSlots(item) {

            const data = {
                exam_plan_id: item.plan_id
            };

            try {

                this.slot_loader = true;

                const res = await axios.post(
                    "/SeatingArrangement/getExamSlots",
                    data
                );

                if (res.data.flag == "YES") {

                    this.examSlotList = (res.data.exam_slot_list || []).map(slot => ({
                        ...slot,
                        isNew: false
                    }));

                } else {

                    this.examSlotList = [];

                    if (res.data.error_trace) {
                        sessionStorage.setItem(
                            "error-trace",
                            res.data.error_trace
                        );
                    }
                }

            } catch (err) {

                this.onerror(err);

            } finally {

                this.slot_loader = false;
            }
        },
        async addSlot() {

            if (!this.selectedExamPlan) {
                this.showSnackbar(
                    "#b71c1c",
                    "Exam plan is not selected."
                );
                return;
            }

            if (
                this.newSlot.slot_no == null ||
                this.newSlot.slot_no == ""
            ) {
                this.showSnackbar(
                    "#b71c1c",
                    "Please enter slot number."
                );
                return;
            }

            if (!this.newSlot.from_time) {
                this.showSnackbar(
                    "#b71c1c",
                    "Please select from time."
                );
                return;
            }

            if (!this.newSlot.to_time) {
                this.showSnackbar(
                    "#b71c1c",
                    "Please select to time."
                );
                return;
            }

            if (
                this.newSlot.from_time >=
                this.newSlot.to_time
            ) {
                this.showSnackbar(
                    "#b71c1c",
                    "To time must be greater than from time."
                );
                return;
            }

            const duplicateSlot = this.examSlotList.some(
                slot =>
                    Number(slot.slot_number) ===
                    Number(this.newSlot.slot_no)
            );

            if (duplicateSlot) {
                this.showSnackbar(
                    "#b71c1c",
                    "This slot number already exists."
                );
                return;
            }

            const data = {

                exam_plan_id:
                    this.selectedExamPlan.plan_id,

                slot_no:
                    this.newSlot.slot_no,

                from_time:
                    this.newSlot.from_time,

                to_time:
                    this.newSlot.to_time
            };

            try {

                this.slot_loader = true;

                const res = await axios.post(
                    "/SeatingArrangement/saveExamSlot",
                    data
                );

                if (res.data.flag == "YES") {

                    this.showSnackbar(
                        "#4caf50",
                        "Slot added successfully."
                    );

                    this.examSlotList.push({
                        ...(res.data.exam_slot || data),
                        isNew: true
                    });

                    this.resetNewSlot();
                    await this.getData();
                    this.updateSelectedExamPlan();

                } else {

                    this.showSnackbar(
                        "#b71c1c",
                        res.data.msg || "Unable to add slot."
                    );

                }

            } catch (err) {

                this.onerror(err);

            } finally {

                this.slot_loader = false;
            }
        },
        resetNewSlot() {

            this.newSlot = {
                slot_no: null,
                from_time: null,
                to_time: null,
                menuFrom: false,
                menuTo: false
            };
        },
        generateTimeSlots() {
            this.timeSlots = [];
            for (let i = 0; i < this.timeSlotCount; i++) {
                this.timeSlots.push({
                    fromTime: "",
                    endTime: "",
                    menuFrom: false,
                    menuEnd: false,
                });
            }
        },
        onTimeChange(index, type, newTime) {
            this.timeSlots[index][type] = newTime;
        },
        addSchedule(item) {
            this.exam_plan_data = item;
            this.dialog_add = true;
            this.getCrsExamPlan();
        },
        getFiltered(e) {
            this.filterArr = e;
        },
        columnValueList(val) {
            return this.exam_crs_sechedule_list.map((d) => d[val]);
        },
        deleteSchedule(item) {
            this.exam_plan_id = item.plan_id
            this.delete_dailog = true
        },
        deleteExamPlan(exam_plan_id) {
            this.delete_loader = true

            axios({
                method: "POST",
                url: "/SeatingArrangement/deleteExamPlan",
                data: {
                    exam_plan_id: exam_plan_id
                },
            })
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.snackbar = true
                        this.color = "green"
                        this.snackbar_msg = res.data.msg

                        this.delete_dailog = false
                        this.exam_plan_id = null

                        this.getData()
                    } else {
                        this.snackbar = true
                        this.color = "red"
                        this.snackbar_msg = res.data.msg
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong");
                })
                .finally(() => {
                    this.delete_loader = false
                })
        },
        async savePlanStatus(item, type, status) {
            const data = {
                exam_plan: item.plan_id,
                type: type,
                status: status
            };
            try {
                const res = await axios.post("/Examination/savePlanStatus", data);
                if (res.data.flag == "YES") {
                    this.showSnackbar("#4caf50", "Status updated successfully");
                    this.getData();
                } else {
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.fetch_loader = false;
            } catch (err) {
                this.onerror(err);
            } finally {
            }
        },
        async getCrsExamPlan() {
            this.exam_crs_echedule_list = [];
            const data = {
                exam_plan: this.exam_plan_data.plan_id,
            };
            try {
                const res = await axios.post("/Examination/getCrsExamPlan", data);
                if (res.data.flag == "YES") {
                    this.exam_crs_sechedule_list = res.data.exam_crs_sechedule_list;
                } else {
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.fetch_loader = false;
            } catch (err) {
                this.onerror(err);
            } finally {
            }
        },
        async saveCrsExamPlan(exam_crs_slot, exam_crs_std, crs_id) {
            const data = {
                standard: exam_crs_std,
                slot: exam_crs_slot,
                crs_id: crs_id,
            };
            try {
                const res = await axios.post("/Examination/saveCrsExamPlan", data);
                if (res.data.flag == "YES") {
                    this.showSnackbar("#4caf50", "Save successfully");
                    this.getCrsExamPlan();
                }
                else if (res.data.flag == "NO") {
                    this.showSnackbar("#4caf50", res.data.fmsg);
                    this.getCrsExamPlan();
                } else {
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.fetch_loader = false;
            } catch (err) {
                this.onerror(err);
            } finally {
            }
        },
        getStdCourse(exam_crs_std) {
            this.crs_list = [];
            const data = {
                ay: this.sel_ay_data.ay_id,
                standard: exam_crs_std,
            };
            axios
                .post("/Examination/getStandardCourse", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.crs_list = res.data.courses_list;
                    }
                    if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", "No courses offered for this standard..."); // show snackbar
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => { });
        },
        async getData() {
            this.get_loader = true;
            const data = {
                ay: this.sel_ay_data.ay_id,
                sem: this.sem
            };
            try {
                const res = await axios.post("/SeatingArrangement/getExamPlan", data);
                if (res.data.flag == "YES" && res.data.exam_plan_list.length == 0) {
                    this.showSnackbar("error", "No data found")
                    this.exam_plan_list = []
                }
                else if (res.data.flag == "YES") {
                    this.exam_plan_list = res.data.exam_plan_list;
                } else {
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.get_loader = false;
            } catch (err) {
                this.onerror(err);
            } finally {
                this.get_loader = false;
            }
        },
        async getExamConductTypes() {
            try {
                const res = await axios.post("/SeatingArrangement/getExamConductTypes");
                if (res.data.flag == "YES") {
                    this.exam_conduct_type = res.data.exam_conduct_type;
                } else {
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
            } catch (err) {
                this.onerror(err);
            } finally {
            }
        },
        async saveplandetails() {
            for (var i = 0; i < this.timeSlots.length; i++) {
                if (this.timeSlots[i].fromTime == "" || this.timeSlots[i].fromTime == null) {
                    this.showSnackbar("#b71c1c", "Please enter from time of slot number " + (i + 1));
                    return;
                } else if (this.timeSlots[i].endTime == "" || this.timeSlots[i].endTime == null) {
                    this.showSnackbar("#b71c1c", "Please enter end time of slot number " + (i + 1));
                    return;
                }
            }
            const data = {
                timeSlots: this.timeSlots,
                ay: this.selAyData.ay_id,
                std: this.sel_std_data,
                ass_type: this.assessment_detail,
                from_date: this.new_from_date,
                to_date: this.new_to_date,
                exam_name: this.exam_name,
                timeSlotCount: this.timeSlotCount,
                sem: this.sel_sem,
                exam_conduct_type_selected: this.exam_conduct_type_selected,
                stream: this.stream,
                supervisor_enabled: this.supervisor_enabled,
                benchwise_allocation: this.benchwise_allocation

            };
            this.fetch_loader = true;
            try {
                const res = await axios.post("/SeatingArrangement/saveExamPlan", data);
                if (res.data.flag == "YES") {
                    this.showSnackbar("#4caf50", "Save successfully");
                    this.getData();
                    this.fetch_loader = false;
                    (this.timeSlots = []),
                        (this.selAyData = null),
                        (this.sel_std_data = null),
                        (this.assessment_detail = null),
                        (this.new_from_date = null),
                        (this.new_to_date = null),
                        (this.exam_name = null),
                        (this.timeSlotCount = null),
                        (this.exam_conduct_type_selected = 1),
                        (this.benchwise_allocation = false),
                        (this.supervisor_enabled = false),
                        (this.stream = []),
                        (this.sel_sem = null);
                } else {
                    this.showSnackbar("error", res.data.msg);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.fetch_loader = false;
            } catch (err) {
                this.onerror(err);
                this.fetch_loader = false;
            } finally {

            }
        },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;
            const [month, day, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
        putnull3() {
            this.show = false;
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please Select Proper Data.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        getStd() {
            this.std_div_list = null;
            this.sel_std_data = null;
            this.div_list = null;
            this.div = null;
            this.std_div_list = this.selAyData.std_list;
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onload() {
            axios
                .post("/commonAPI/get_ay_std_div")
                .then((res) => {
                    this.ay_std_div_list = res.data.data;
                    this.semester_list = res.data.semester_list_wws;
                    // this.sem = this.semester_list;
                    this.assessment_detail_list = res.data.assessment_detail_list;
                    this.stream_list = res.data.stream_list;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => { });
        },
    },
    mounted() {
        this.onload();
        this.getExamConductTypes();
    },
};
</script>
<style scoped>
.exam-plan-dialog ::v-deep .v-input__prepend-inner .v-icon {
    font-size: 18px !important;
}

.mytable {
    border-radius: 8px;
    overflow: hidden;
}

.mytable ::v-deep .v-data-table__wrapper {
    border-radius: 8px;
}

.mytable ::v-deep table {
    border-collapse: separate;
    border-spacing: 0;
}

.mytable ::v-deep thead th {
    background: #f5f7fa !important;
    color: #37474f !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    white-space: nowrap;
    height: 44px !important;
    border-bottom: 1px solid #dfe3e8 !important;
    text-align: center !important;
    vertical-align: middle !important;
}

.mytable ::v-deep tbody td {
    font-size: 13px !important;
    padding: 8px 10px !important;
    white-space: nowrap;
    border-bottom: 1px solid #eeeeee !important;
    text-align: center !important;
    vertical-align: middle !important;
}

.mytable ::v-deep tbody tr:hover {
    background: #fafafa !important;
}

.mytable ::v-deep .v-input--switch {
    margin-top: 0;
    padding-top: 0;
}

.mytable ::v-deep .v-input--selection-controls {
    margin: 0;
    padding: 0;
}

.mytable .v-btn {
    margin: 2px;
}

.mytable ::v-deep .v-data-table__empty-wrapper {
    height: 80px;
}

.mytable ::v-deep th,
.mytable ::v-deep td {
    text-align: center !important;
    vertical-align: middle !important;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.exam-coursewise-card {
    overflow: hidden;
}

.exam-coursewise-body {
    max-height: calc(100vh - 100px);
    overflow-y: auto;
}

.exam-summary-card,
.add-schedule-card,
.schedule-list-card {
    border-radius: 8px;
}

.info-label {
    font-size: 11px;
    color: #777;
    margin-bottom: 2px;
    text-transform: uppercase;
}

.info-value {
    font-size: 14px;
    font-weight: 500;
}

.schedule-table-wrapper {
    width: 100%;
    overflow-x: auto;
}

.coursewise-table {
    min-width: 1000px;
}

.coursewise-table th {
    white-space: nowrap;
}

.coursewise-table td {
    white-space: nowrap;
}
</style>
